import * as React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { getImgPath } from '../store/StringTool';
import { useSelector, useDispatch } from 'react-redux';
import { settingActions, settingObj } from '../store/SettingSlice';
import * as StringTool from '../store/StringTool';


export default function TermsPage() {

    const dispatch = useDispatch();
    const settingData = useSelector(state => state.settingData);

    React.useEffect(() => {
        dispatch(settingActions.setRegion(StringTool.getRegion()));
    }, []);

    return (
        <Stack sx={{
            bgcolor: 'black',
            width: 1,
            minHeight: window.innerHeight,
            alignItems: 'center',
        }}>

            <Stack
                onMouseOver={() => {
                    dispatch(settingActions.setMousewheel(false))
                }}
                onMouseLeave={() => {
                    dispatch(settingActions.setMousewheel(true))
                }}
                sx={{
                    width: 1,
                    zIndex: 5,
                    position: 'absolute',
                    height: `${window.innerHeight}px`,
                    overflow: 'scroll',
                    alignItems: 'center',
                }}>

                <Box
                    component={'div'}
                    sx={{
                        color: '#999999',
                        maxWidth: '1000px',
                        py: 3,
                        mx: 1.5,
                    }}
                    dangerouslySetInnerHTML={{
                        __html:
                            `
                        ${getContent(settingData.region)}
                            `
                    }} />

            </Stack>

        </Stack>
    );
}

function getContent(l) {
    if (l == 'en') {
        return getEnStr();

    } else if (l == 'jp') {
        return getJpStr();

    } else if (l == 'kr') {
        return getKrStr();
    }
    return '';
}

function getJpStr() {
    return `
    <!DOCTYPE html>
    <html>
        <head>
            <meta charset="utf-8">
            <title>Privacy Policy</title>
              <meta name="format-detection" content="telephone=no" />
              <meta name="viewport" content="width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no" />
              <style type="text/css">

              p {
                margin: 5px;
                font-family: "NotoSansJP Regular";
            }
    
            .t2 {
                font-size: 28px;
                font-family: "NotoSansJP SemiBold";
                line-height: 1.2;
            }
            .news_body{
                color: #f4f4f4;
            }      
    
            .column-policy {
                width: 90%;
                margin: auto;
                font-family: NotoSansJP SemiBold;
                font-size: 15px;
                line-height: 20px;
                color: #666666;
            }
    
            .title_policy {
                text-align: center;
                font-size: 30px;
                padding-top: 10px;
                display: inline-block;
                width: 100%;
                line-height: 1.2;
                padding-bottom: 10px;
            }
    
            .title-small {
                width: 100%;
                margin-top: 20px;
                font-size: 16px;
                color: #777;
                line-height: 1.2;
                padding-bottom: 5px;
            }
    
            .dot_small_title {
                margin-left: 20px;
                padding: 5px 20px 5px 10px;
                list-style-type: disc;
            }
    
            .title-big {
                width: 100%;
                margin-top: 30px;
                font-size: 20px;
                color: #999;
                line-height: 1.2;
                padding: 0 0 10px 0;
            }
    
            .index{
                color: #929392;
                display: inline-block;
                margin-right: 5px;
            }
            @media (max-width: 1024px) {
                td{
                    padding: 5px 2px;
                }
                .column-policy {
                    font-size: 14px;
                    width: 96%;
                }
                table{
                    position: relative;
                    left: -1%;
                }
                .wrp{
                    padding-bottom: 0;
                }
            }
       
              </style>
        </head>
        <body>


        <div class="wrp">
		<div class="wrp2">
			<div class="mask"></div>
            <div class="news_show">
                <div class="news_body column-policy" id="privacyDetail">
                    <div class="WordSection1" >
                        <p style="margin-bottom:
                        4.0pt;text-align:center;"><span class="title_policy">利用規約</span><span><o:p></o:p></span></p>                        
                        <p style="margin-bottom:
                        8.0pt;text-align:center;"><span  >制定日：2023年8月15日</span><span><o:p></o:p></span></p>
                        <p>この規約（以下「本規約」といいます。）は、A PLUS JAPAN株式会社（以下「当社」といいます。）が提供するすべての製品およびサービス（以下「本サービス」といいます。）の利用に関する条件を定めるものです。</p>
                        <p>&nbsp;</p>
                        <p class="t2">1.定義</p>
                        <p>本規約で使用される用語の定義は以下のとおりです。</p>
                        <p>(1)「コンテンツ」とは、文章、音声、音楽、画像、動画、ソフトウェア、プログラム、コードその他の情報のことをいいます。</p>
                        <p>(2)「本コンテンツ」とは、本サービスを通じてアクセスすることができるコンテンツのことをいいます。</p>
                        <p>(3)「本サービス通貨」とは、本サービスにおいて有償で提供されるサービスまたはコンテンツと交換可能な前払式支払手段およびこれに類するもののことをいいます。</p>
                        <p>(4)「個別利用条件」とは、本サービスに関して、本規約とは別に当社が配布または掲示している条件のことをいいます。</p>
                        <p>&nbsp;</p>
                        <p class="t2">2.規約への同意</p>
                        <p>(1)お客様は、本規約の定めに従って本サービスを利用しなければなりません。お客様は、本規約に同意をしない限り本サービスを利用できません。</p>
                        <p>(2)お客様が未成年者である場合は、親権者等の法定代理人の同意を得たうえで本サービスを利用してください。</p>
                        <p>(3)本サービスにおいて個別利用条件がある場合、お客様は、本規約のほか個別利用条件の定めにも従って本サービスを利用しなければなりません。</p>
                        <p>&nbsp;</p>
                        <p class="t2">3.規約の変更</p>
                        <p>当社は、必要に応じて、法令に基づき、本サービスの目的の範囲内で、本規約を変更することがあります。その場合、当社は、変更後の本規約の内容を、当社が定める方法によりお客様に通知します。これにより、お客様は、変更後の本規約を承諾したものとします。</p>
                        <p>&nbsp;</p>
                        <p class="t2">4.アカウント</p>
                        <p>(1)本サービスの利用に際して、情報を登録のうえ、アカウントの作成が必要となる場合があります。この場合、お客様は、真実、正確かつ完全な情報を登録しなければならず、常に最新の情報となるよう修正しなければなりません。</p>
                        <p>(2)お客様は、本サービスの利用に際して認証情報を登録する場合、これを不正に利用されないようご自身の責任で厳重に管理しなければなりません。当社は、登録されたお客様の認証情報を利用して操作が行われた場合、お客様ご本人の行為として本サービスを提供します。</p>
                        <p>(3)本サービスに登録したお客様は、いつでもアカウントを削除して退会することができます。</p>
                        <p>(4)お客様の本サービスにおけるすべての利用権は、理由を問わず、アカウントが削除された時点で消滅します。お客様が誤ってアカウントを削除した場合であっても、アカウントの復旧はできませんのでご注意ください。</p>
                        <p>(5)本サービスのアカウントは、第三者に譲渡、貸与その他の処分または相続させることはできません。</p>
                        <p>&nbsp;</p>
                        <p class="t2">5.プライバシー</p>
                        <p>当社は、お客様のプライバシー情報と個人情報を、当社プライバシーポリシーに従って適切に取り扱います。</p>
                        <p>&nbsp;</p>
                        <p class="t2">6.サービスの提供</p>
                        <p>(1)お客様は、本サービスを利用するにあたり、必要なパーソナルコンピュータ、携帯電話機、スマートフォンその他の通信機器、オペレーションシステム、通信手段および電力等を、お客様の費用と責任で用意するものとします。</p>
                        <p>(2)当社は、本サービスの全部または一部を、年齢、本人確認の有無、登録情報の有無、その他、当社が必要と判断する条件を満たしたお客様に限定して提供することができます。</p>
                        <p>(3)当社は、当社が必要と判断する場合、あらかじめお客様に通知することなく、いつでも、本サービスの全部または一部の内容を変更することができます。</p>
                        <p>(4)当社は、以下のいずれかに該当する場合、あらかじめお客様に通知することなく、本サービスの全部または一部の提供を中止することができます。</p>
                        <p>①システムのメンテナンスまたは修理の実施を行う場合</p>
                        <p>②火災・停電等の事故、天災、戦争、暴動等の不可抗力により、本サービスの提供ができなくなった場合</p>
                        <p>③システムの障害が発生した場合またはシステムに負荷が集中した場合</p>
                        <p>④お客様または第三者の安全を確保する場合または公共の利益のために緊急を要する場合</p>
                        <p>⑤その他当社が必要と合理的に判断した場合</p>
                        <p>&nbsp;</p>
                        <p class="t2">7.広告表示</p>
                        <p>当社は、本サービスに当社または第三者の広告を掲載することができます。</p>
                        <p>&nbsp;</p>
                        <p class="t2">8.当社以外の第三者のサービス</p>
                        <p>本サービスは、当社以外の第三者が提供するサービスまたはコンテンツを含む場合があります。かかるサービスまたはコンテンツに対する責任は、これを提供する第三者が負います。また、かかるサービスまたはコンテンツには、これを提供する第三者が定める利用規約その他の条件が適用されることがあります。</p>
                        <p>&nbsp;</p>
                        <p class="t2">9.コンテンツ</p>
                        <p>(1)当社は、当社が提供する本コンテンツについて、お客様に対し、譲渡および再許諾できず、非独占的な、本サービスの利用を唯一の目的とする利用権を付与します。</p>
                        <p>(2)お客様は、利用料、利用期間その他の利用条件が別途定められた本コンテンツを利用する場合、かかる利用条件に従うものとします。当社がお客様に対し提供する本コンテンツに関する知的財産権その他の権利は、当社に留保され、お客様に移転するものではありません。</p>
                        <p>(3)お客様は、本コンテンツを、本サービスが予定している利用態様を超えて利用(複製、送信、転載、改変を含みます。)してはなりません。</p>
                        <p>(4)本コンテンツに登録されたお客様の情報及びデータのバックアップは、お客様ご自身で行っていただくこととなります。当社はこれらのバックアップを行う義務を負いません。</p>
                        <p>(5)当社は、法令または本規約の遵守状況等を確認する必要がある場合、法令に反しない限り、本コンテンツに登録されたお客様の情報及びデータの内容を確認することができます。ただし、当社はそのような確認を行う義務を負うものではありません。</p>
                        <p>(6)当社は、本コンテンツに登録されたお客様の情報及びデータに関し法令もしくは本規約に違反し、または違反するおそれがあると認めた場合、その他業務上合理的な必要がある場合、あらかじめお客様に通知することなく、本コンテンツに登録されたお客様の情報及びデータを削除する等の方法により、本サービスの利用を制限できます。</p>
                        <p>&nbsp;</p>
                        <p class="t2">10.本サービス通貨</p>
                        <p>(1)本サービス通貨は、本サービスでの購入、キャンペーンその他、当社が指定する方法により、お客様に付与されます。本サービス通貨の購入単位、決済方法、その他の本サービス通貨の付与条件は、当社が定め本サービスまたは当社ウェブサイトに表示します。</p>
                        <p>(2)本サービス通貨は、当社が指定するサービスまたはコンテンツ以外の、現金、財物その他の経済上の利益と交換することはできません。サービスまたはコンテンツとの交換に必要な本サービス通貨数、その他本サービス通貨の交換条件は、当社が定め本サービスまたは当社ウェブサイトに表示します。</p>
                        <p>(3)本サービス通貨は、これを取得したアカウントでのみ利用できます。</p>
                        <p>(4)本サービス通貨は、理由を問わず、一切払戻しを行いません。ただし、法令上必要な場合はこの限りではありません。この場合、本サービス通貨の払戻方法は、法令に従って当社が定め、当社のウェブサイト等に表示します。</p>
                        <p>&nbsp;</p>
                        <p class="t2">11.ポイント等の変更・廃止</p>
                        <p>(1)当社は、本サービス通貨その他のポイント等が使用できるサービスの内容の全部または一部の変更、追加または廃止をし、未使用のポイント等を消滅させることができます。</p>
                        <p>(2)前項の場合、当社は、当社が合理的と判断する期間、ポイント等の廃止の範囲および廃止日を本アプリケーションまたは公式サイト上で事前に告知するものとします。ただし、法令で別段の定めがある場合には、それに従うものとします。</p>
                        <p>(3)当社は、ポイント等の消滅によってお客様に生じた損害につき、法令に基づき当社に払戻し義務がある場合、当社が別途案内をした場合、または当社に故意もしくは重過失がある場合を除き、一切の責任を負いません。</p>
                        <p>&nbsp;</p>
                        <p class="t2">12.本サービス情報の掲載</p>
                        <p>(1)当社は、本サービスにおいて、お客様が他の特定または不特定のお客様に対して文章、画像、映像、プログラム、データその他の情報（以下「送信情報」といいます）を投稿、送信、掲載等する仕組みを提供することがあります。</p>
                        <p>(2)お客様は、自身の送信情報について一切の責任を負うものとします。</p>
                        <p>(3)お客様は、自身の送信情報、および当社による送信情報の本規約に基づく利用が、第三者の知的財産権、プライバシー権、肖像権その他の人格権または人格的利益を侵害しないことを保証するものとします。</p>
                        <p>(4)お客様は、自身の送信情報に関して第三者から苦情の申立て、訴訟の提起その他の紛争が生じた場合、お客様自身の責任と費用によりこれを解決するものとします。当社は、当該紛争について何ら責任を負いません。</p>
                        <p>(5)当社は、お客様の送信情報をあらゆる態様で利用および使用し（複製し、送信し、第三者に提供し、内容を調査し、本サービスの不正行為を調査し、本サービスまたは本サービス以外の広告宣伝活動に利用し、ならびに編集または改変した送信情報をこれらの態様で利用および使用することを含みますが、これに限りません）、または第三者による当該利用および使用を許諾することができるものとします。お客様は、当社および当該第三者による送信情報の利用を、無償、無期限かつ無条件で許諾するものとします。</p>
                        <p>(6)当社は、当社が必要と判断した場合、お客様に対して事前に通知することなく、お客様の送信情報を公開の前後を問わず閲覧し、およびその全部または一部の公開を中止しまたは削除することができるものとします。</p>
                        <p>&nbsp;</p>
                        <p class="t2">13.禁止事項</p>
                        <p>当社は、本サービスに関するお客様による以下の行為を禁止します。</p>
                        <p>(1)法令、裁判所の判決、決定もしくは命令、または法令上拘束力のある行政措置に違反する行為</p>
                        <p>(2)公の秩序または善良の風俗に反するおそれのある行為</p>
                        <p>(3)当社または第三者の著作権、商標権、特許権等の知的財産権、名誉権、プライバシー権、その他法令上または契約上の権利を侵害する行為</p>
                        <p>(4)過度に暴力的な表現、露骨な性的表現、児童ポルノ・児童虐待に相当する表現、人種、国籍、信条、性別、社会的身分、門地等による差別につながる表現、自殺、自傷行為、薬物乱用を誘引または助長する表現、その他反社会的な内容を含み他人に不快感を与える表現を、投稿または送信する行為</p>
                        <p>(5)自殺もしくは自傷に結びつく行為、またはこれを教唆もしくは幇助する行為</p>
                        <p>(6)当社または第三者になりすます行為または意図的に虚偽の情報を流布させる行為</p>
                        <p>(7)当社が定める方法以外の方法で、本サービスまたは本コンテンツの利用権を、現金、財物その他の経済上の利益と交換する行為</p>
                        <p>(8)営業、宣伝、広告、勧誘、その他営利を目的とする行為（当社の認めたものを除きます。）、性行為やわいせつな行為を目的とする行為、面識のない第三者との出会いや交際を目的とする行為、他のお客様に対する嫌がらせや誹謗中傷を目的とする行為、その他本サービスが予定している利用目的と異なる目的で本サービスを利用する行為</p>
                        <p>(9)反社会的勢力に対する利益供与その他の協力行為</p>
                        <p>(10)宗教活動または宗教団体への勧誘行為</p>
                        <p>(11)他人の個人情報、登録情報、利用履歴情報等を、不正に収集、開示または提供する行為</p>
                        <p>(12)本サービスのサーバやネットワークシステムに支障を与える行為、BOT、チートツール、その他の技術的手段を利用して本サービスを不正に操作する行為、本サービスの不具合を意図的に利用する行為、同様の質問を必要以上に繰り返す等、当社に対し不当な問い合わせまたは要求をする行為、その他当社による本サービスの運営または他のお客様による本サービスの利用を妨害し、これらに支障を与える行為</p>
                        <p>(13)不当な目的または態様でのリバースエンジニアリング、逆アセンブルを行う行為、その他の方法でソースコードを解読する行為</p>
                        <p>(14)上記に定めるもののほか、未成年の健全育成に支障が生じ得るすべての行為</p>
                        <p>(15)上記に定めるもののほか、当社が不適当と合理的に判断した行為</p>
                        <p>&nbsp;</p>
                        <p class="t2">14.お客様の責任</p>
                        <p>(1)お客様は、お客様ご自身の責任において本サービスを利用するものとします。</p>
                        <p>(2)当社は、お客様が以下のいずれかに該当する場合または該当するおそれがある場合、あらかじめお客様に通知することなく、本サービスの全部または一部の利用の停止、アカウントの停止または削除、本サービスに関するお客様と当社との間の契約（本規約に基づく契約を含みます。以下同じ。）の解除その他の当社が必要かつ適切と合理的に判断する措置を講じることができます。</p>
                        <p>①適用のある法令または本規約もしくは個別利用条件に違反した場合</p>
                        <p>②反社会的勢力の構成員またはその関係者である場合</p>
                        <p>③風説の流布、偽計、威力その他の不正な手段を用いて当社の信用を毀損する場合</p>
                        <p>④差押え、仮差押えもしくは競売の申立てを受けた場合、または破産手続開始、民事再生手続開始もしくはこれらに類する手続の開始の申立てがあった場合その他お客様の信用不安が発生したと当社が合理的に判断した場合</p>
                        <p>⑤上記に定めるもののほか、お客様との信頼関係が失われた場合その他お客様への本サービスの提供が適切でないと当社が合理的に判断した場合</p>
                        <p>(3)お客様は、本サービスを利用したことに起因して（当社がかかる利用を原因とするクレームを第三者より受けた場合を含みます。）、当社が直接的または間接的に何らかの損害（弁護士費用の負担を含みます。）を被った場合、法令に基づき、当社の請求にしたがって直ちにこれを賠償しなければなりません。</p>
                        <p>&nbsp;</p>
                        <p class="t2">15.本サービスの終了</p>
                        <p>(1)本サービスは、以下のいずれかの事由の発生により終了するものとします。</p>
                        <p>①お客様による、本サービスのデバイスからの削除（ただし、お客様のアカウントを用いて異なるデバイスにデータを移行するなど、当社が別途指定する方法により、お客様が本サービスの利用を継続する場合は、この限りではありません）</p>
                        <p>②本サービスの提供の終了</p>
                        <p>(2)当社は、お客様が以下のいずれかに該当する場合、本サービスを終了させることができるものとします。</p>
                        <p>①お客様またはお客様の利用するアカウントが、過去に当社のサービス（本サービスを含みますが、これに限りません）の利用に際して、利用停止措置または当該サービスに関する利用契約の解除を受けたことがある場合</p>
                        <p>②別途当社が定める期間にわたり、本サービスの利用実態がない場合</p>
                        <p>③お客様が死亡した場合（当社はお客様の死亡について調査義務を負うものではありません）</p>
                        <p>④本規約に違反した場合</p>
                        <p>⑤上記に定めるものの他、お客様への本サービスの提供が不適切または不可能であると当社が判断した場合</p>
                        <p>&nbsp;</p>
                        <p class="t2">16.知的財産権</p>
                        <p>(1)本サービスにおいて当社がお客様に提供するコンテンツに関する知的財産権は、当社または当社にその利用を許諾した者（以下「ライセンサー」といいます）に帰属します。お客様は、著作権法その他の法令に基づき認められる場合を除き、当社またはライセンサーの許諾なくコンテンツを複製、送信その他の態様で使用してはならず、第三者に使用させてはなりません。</p>
                        <p>(2)本サービスに関して表示される人名、企業名、商品名、サービス名その他の名称（以下、総称して「商標等」といいます）には、当社または第三者が商標権その他の使用権を有する名称が含まれます。当社は、商標等が当社または第三者の登録商標その他の知的財産権であることを、本サービス上に記載することがありますが、この記載がない商標等であっても、当社または第三者が使用権を有することがあります。</p>
                        <p>(3)本規約は、お客様その他の第三者に対し、商標等を譲渡し、または使用許諾するものとは解釈されないものとします。</p>
                        <p>(4)お客様は、本サービスに関する知的財産権について、その登録を出願し、移転を申請し、または行使してはならないものとします。</p>
                        <p>&nbsp;</p>
                        <p class="t2">17.非保証</p>
                        <p>当社は、本サービス（本コンテンツを含みます。）に関する瑕疵（セキュリティ等に関する欠陥、エラーやバグ、権利侵害を含みます。）がないこと、ならびに安全性、信頼性、正確性、完全性、有効性および特定の目的への適合性を明示的にも黙示的にも保証していません。当社は、お客様に対して、かかる瑕疵を除去して本サービスを提供する義務を負いません。</p>
                        <p>&nbsp;</p>
                        <p class="t2">18.当社の免責</p>
                        <p>(1)当社は、当社の故意または重過失に起因する場合を除き、本サービスに起因してお客様に生じたあらゆる損害について一切の責任を負いません。</p>
                        <p>(2)当社の重過失に起因してお客様に損害が生じた場合、当社は、逸失利益その他の特別の事情によって生じた損害を賠償する責任を負わず、通常生ずべき損害の範囲内で損害賠償責任を負うものとします。</p>
                        <p>&nbsp;</p>
                        <p class="t2">19.本規約と法令の関係</p>
                        <p>本規約の規定が適用される法令に反するとされる場合でも、本規約の他の規定の効力に影響しないものとします。</p>
                        <p>&nbsp;</p>
                        <p class="t2">20.連絡方法</p>
                        <p>(1)本サービスに関する当社からお客様への連絡は、本サービスまたは当社ウェブサイト内の適宜の場所への掲示その他、当社が適当と判断する方法により行います。</p>
                        <p>(2)本サービスに関するお客様から当社への連絡は、本サービスまたは当社ウェブサイト内の適宜の場所に設置するお問い合わせフォームの送信または当社が指定する方法により行っていただきます。</p>
                        <p>&nbsp;</p>
                        <p class="t2">21.準拠法、裁判管轄</p>
                        <p>本規約の準拠法は日本法とします。本サービスに起因または関連してお客様と当社との間に生じた紛争については東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>
                        <p>&nbsp;</p>
                </div>
            </div>
        </div>
    </div>
</div>


        </body>
        </html>
    `
}

function getKrStr() {
    return `

    <!DOCTYPE html>
    <html>
        <head>
            <meta charset="utf-8">
            <title>Privacy Policy</title>
              <meta name="format-detection" content="telephone=no" />
              <meta name="viewport" content="width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no" />
              <style type="text/css">

              .news_body{
                color: #f4f4f4;
            }
            table{
                margin-top: 10px;
                border-collapse: collapse;
                width: 100%;
            }
            td{
                padding: 5px 10px;
            }
            table, td, th{
                border: 1px solid #A6A6A6;
            }
    
            .column-policy {
                width: 90%;
                margin: auto;
                font-family: Arial, Helvetica, sans-serif;
                font-size: 15px;
                line-height: 20px;
                color: #666666;
            }
    
            .title_policy {
                text-align: center;
                font-size: 30px;
                padding-top: 10px;
                display: inline-block;
                width: 100%;
                line-height: 1.2;
                padding-bottom: 10px;
            }
    
            .title-small {
                width: 100%;
                margin-top: 20px;
                font-size: 16px;
                color: #777;
                line-height: 1.2;
                padding-bottom: 5px;
            }
    
            .dot_small_title {
                margin-left: 20px;
                padding: 5px 20px 5px 10px;
                list-style-type: disc;
            }
    
            .title-big {
                width: 100%;
                margin-top: 30px;
                font-size: 20px;
                color: #999;
                line-height: 1.2;
                padding: 0 0 10px 0;
            }
    
            .index{
                color: #929392;
                display: inline-block;
                margin-right: 5px;
            }
            @media (max-width: 1024px) {
                td{
                    padding: 5px 2px;
                }
                .column-policy {
                    font-size: 14px;
                    width: 96%;
                }
                table{
                    position: relative;
                    left: -1%;
                }
                .wrp{
                    padding-bottom: 0;
                }
            }
       
              </style>
        </head>
        <body>


  <div class="wrp">
		<div class="wrp2">
			<div class="mask"></div>
            <div class="news_show">
                <div class="news_body column-policy" id="privacyDetail">
                    <div class="WordSection1" >
                        <p style="margin-bottom:8.0pt;text-align:center;"><span class="title_policy">서비스 약관</span></p>
                        
                        <p style="margin-bottom:8.0pt;text-align:center;"><span>발효일: 2022년 12월 18일</span></p>
                        
                        <p class="title-big"><b><span>1. 중요 고지 사항 - 중재, 환불, 집단 소송 및 손해 배상</span></b></p>
                        <p><b><span>미국 거주자를 위한 중재 관련 중요 고지 사항: 본 서비스 약관에 동의할 경우 귀하는 법원이 아닌 구속력 있는 개별 중재를 통해 귀하와 당사 사이의 모든 분쟁을 해결하는 데 동의하게 됩니다(제한적 예외 적용). 중재와 관련된 자세한 내용은 아래의 섹션 22 "분쟁 해결"을 주의 깊게 검토하시기 바랍니다. 본 서비스 약관에는 당사를 상대로 한 귀하의 집단 소송 제기 권리 포기 조항 및 귀하의 당사 서비스 사용으로 인해 제기되어 귀하가 당사로부터 받을 수 있는 손해 배상의 제한이 포함됩니다. 서비스를 사용함으로써 귀하는 이러한 조항에 동의하게 됩니다.</span></b></p>
                        
                        <p><b><span>본 서비스 약관의 조항에 동의하지 않을 경우 귀하는 당사 서비스를 설치, 복사 또는 사용할 수 없습니다. 당사는 당사가 명시적으로 승인하는 경우(예외에 관해서는 제10항 참고) 또는 현지 법률에 따라 환불이 요구되는 경우를 제외하고는 일반적으로 환불을 제공하지 않습니다.</span></b></p>
                        
                        <p><b><span>당사 서비스 약관에는 귀하의 거주 관할권에 따라 귀하에게 적용되는 국가별 부록이 포함될 수 있습니다. 귀하에게 해당하는 추가 조항(본 계약의 일부를 구성하며 본 약관에 우선할 수 있음)은 서비스 약관 웹사이트의 국가별 언어를 확인하십시오.</span></b></p>
                        
                        <p class="title-big"><b><span>2. 이 문서는 무엇입니까? 언제 플레이할 수 있습니까?</span></b></p>
                        
                        <p><span>귀하가 읽고 있는 문서는 귀하가 사용하는 당사의 서비스와 관련해 귀하와 A PLUS JAPAN Inc. (이하 <b>“당사”</b>) 사이에 체결된 법적 계약인 당사의 서비스 약관입니다. <b>“서비스”</b>란 (a) 당사 게임, (b) 컴퓨터, 콘솔, 모바일 기기에서 설치 또는 사용하는지 여부에 관계 없이 게임과 함께 또는 게임을 지원하기 위해 당사가 제공하는 웹사이트, 소프트웨어 또는 기타 서비스를 통칭하거나 때로는 개별적으로 의미합니다. <b>“게임”</b>이란 귀하가 다운로드하여 액세스하며 귀하가 다운로드 및/또는 액세스하는 위치에 관계 없이 본 서비스 약관의 적용을 받는 당사의 게임 및 여기에 포함된 문서, 소프트웨어, 업데이트, 가상 상품 및 콘텐츠(각각 아래에 정의됨)를 의미합니다.</span></p>
                        
                        <p><span>당사는 본 서비스 약관을 명확히 하기 위해 노력하며 궁금한 점이 있는 경우 support@sfduelmobile.zendesk.com(이하 당사 <b>“지원 이메일 주소”</b>)으로 연락해 주시기 바랍니다. </span></p>
                        
                        <p class="title-big"><b><span>3. 정의된 용어</span></b></p>
                        
                        <p><span>본 '서비스 약관'에는 일부 따옴표 사이에 들어간 용어가 있습니다. 이를 '정의된 용어'라고 하며, 당사는 동일한 말을 반복하지 않고 용어를 '서비스 약관' 전반에 걸쳐 일관되게 사용하기 위해 이와 같은 용어를 사용합니다.  귀하가 문맥에 따라 쉽게 읽을 수 있도록 전반적으로 정의된 용어를 포함했습니다.</span></p>
                        
                        <p class="title-big"><b><span>4. 추가 용어</span></b></p>
                        
                        <p><span>일부 서비스는 제3자 플랫폼 또는 스토어에 대한 액세스(또는 이러한 플랫폼 또는 스토어에서 다운로드)를 통해 제공(또는 독점 제공)될 수 있으며, 여기에는 Facebook, Epic Games Store, Steam 게임 플랫폼, Google Play Store 및 Apple App Store(각각 <b>“앱 스토어”</b>)가 포함되지만 이에 국한되지 않습니다. 귀하의 서비스 사용에는 앱 스토어와 체결한 관련 계약(이하 <b>“앱 스토어 계약”</b>)도 적용됩니다. 귀하의 서비스 사용과 관련하여 귀하가 당사 게임 중 하나를 획득한 다른 앱 스토어의 계약과 본 서비스 약관 사이에 충돌이 발생할 경우 본 서비스 약관이 우선합니다.</span></p>
                        
                        <p><span>서비스와 관련된 귀하의 정보 수집(앱 스토어를 통해 획득했는지 여부와 무관함)에는 2022년 12월 18일부 당사 개인정보처리방침이 적용됩니다. 당사 개인정보처리방침에는 당사가 귀하로부터, 귀하에 관해 수집하는 정보의 수집, 사용, 공개 방식이 설명되어 있습니다.</span></p>
                        
                        <p class="title-big"><b><span>5. 자격 요건 및 등록</span></b></p>
                        
                        <p><span class="index">(a)</span><span>&nbsp;</span><u><span>연령. </span></u><span>게임 계정(아래에 정의된 바에 따름)을 만들고 당사 서비스에 액세스하려면 귀하는 해당 관할권의 법률에 따라 개인 데이터 수집에 동의할 수 있는 최소 연령 이상이어야 합니다. 귀하가 개인 데이터 수집을 위한 최소 연령과 해당 관할권의 성인 연령 사이에 있는 경우 귀하의 부모 또는 보호자가 본 서비스 약관을 검토하고 귀하를 대신해 이를 수락해야 합니다. 부모 및 보호자는 만 18세 미만의 자녀가 당사 서비스를 사용할 경우 그들의 행위에 대한 책임을 집니다.</span></p>
                        
                        <p><span>당사는 개인 데이터 수집을 위한 최소 연령 미만인 미성년자가 부모 또는 법적 보호자의 확인된 동의를 얻어 특정 서비스에 등록하도록 허용할 수 있습니다. 부모/법적 보호자는 관련 법률에 따라 추가적인 문서를 제공하거나 확인 및 승인 프로세스의 일환으로 추가적인 조치를 취해야 할 수 있습니다. 부모 및 보호자는 자녀에게 제공하는 기기의 자녀 보호 기능을 익혀 두는 것이 좋습니다.</span></p>
                        
                        <p><span class="index">(b)</span><span>&nbsp;</span><u><span>계정 생성. </span></u><span>게임의 일부에 액세스하려면 귀하는 게임 내 계정(이하 귀하의 <b>“게임 계정”</b>)을 만들어야 할 수 있습니다. 귀하의 게임 계정은 앱 스토어에서 사용할 수 있는 계정(이하 귀하의 <b>“앱 스토어 계정”</b>)과는 별도입니다(해당하는 경우). 귀하가 당사에 가지고 있던 기존 계정 또는 귀하의 이메일 주소를 사용하여 게임 계정을 만들 수 있습니다. 제3자 계정을 사용하여 귀하의 게임 계정을 만드는(예: Facebook 또는 Google을 사용하는 계정) 범위 내에서 당사는 게임 계정을 만들기 위해 그러한 제3자가 당사에 제공하는 귀하의 이메일 주소, 이름 등의 특정 개인 정보에 액세스할 수 있습니다. 제3자 계정의 사용에 관한 추가 정보는 2022년 12월 18일부 개인정보처리방침을 통해 제공됩니다. 게임 계정을 만들지 않고도 게임을 플레이할 수 있으나 게임에 특정 부분에는 액세스할 수 없으며 게임을 제거하거나 달리 삭제할 경우 게임 데이터가 삭제될 수 있습니다.</span></p>
                        
                        <p><span class="index">(c)</span><span>&nbsp;</span><u><span>최신 정보 유지. </span></u><span>.게임 계정에 정확하고 완전한 최신 정보를 제공해야 하며 이러한 상태를 유지하기 위해 귀하는 이러한 정보를 업데이트하는 데 동의합니다. 그러지 않을 경우 당사는 귀하의 게임 계정을 일시 중지하거나 해지할 수 있습니다. 귀하는 귀하의 게임 계정 비밀번호를 누구에게도 공개하지 않을 것이며, 귀하의 게임 계정에 대한 무단 사용이 있을 경우 당사에 즉시 고지한다는 데 동의합니다. 귀하가 인지하고 있는지 여부에 관계없이 귀하의 게임 계정에서 발생하는 모든 활동에 관해서는 귀하가 책임을 집니다. 귀하가 귀하의 게임 계정이 더 이상 안전하지 않다고 판단할 경우 당사 지원 이메일 주소로 당사에 즉시 알려야 합니다.</span></p>
                        
                        <p><span class="index">(d)</span><span>&nbsp;</span><u><span>계정 공유 금지.</span></u><span>Y귀하는 귀하의 게임 계정을 타인에게 판매, 재판매, 대여, 임대, 공유하거나 접근 권한을 제공할 수 없습니다. 당사는 당사 서비스에 대한 무단 사용을 방지하기 위해 가용한 모든 법적 권리 및 구제 조치를 보유하며, 이는 기술적 장벽, IP 매핑 및 심각한 경우 그러한 무단 사용과 관련해 귀하의 인터넷 서비스 제공업체(ISP)에 직접 문의하는 방안을 포함하되 이에 국한되지 않습니다.</span></p>
                        
                        <p><span class="index">(e)</span><span>&nbsp;</span><u><span>사칭 계정 금지. </span></u><span>귀하는 타인을 위해 게임 계정을 만들거나 본인이 아닌 다른 이름으로 게임 계정을 만들 수 없습니다.</span></p>
                        
                        <p class="title-big"><b><span>6. 라이선스 및 서비스 사용</span></b></p>
                        
                        <p><span class="index">(a)</span><span>&nbsp;</span><u><span>라이선스 부여. </span></u><span>본 '서비스 약관' 및 '앱 스토어 계약'(해당하는 경우)을 준수하는 한 당사는 귀하에게 (i) '앱 스토어 계약'(해당하는 경우)에서 허용하는 기기에 '게임'을 다운로드하고 설치하며 (ii) 개인 오락 목적으로 '게임' 및 '서비스'의 기능만을 활용하는 모든 '콘텐츠'를 포함해 '서비스'에 액세스하고 이를 사용할 수 있는 개인적이고 비배타적이며 양도 및 재라이선스가 불가한 제한적 권리 및 라이선스를 부여합니다. 당사와 당사의 라이선스 부여자는 본 '서비스 약관'에서 귀하에게 부여되지 않은 모든 권리를 보유합니다. <b>“콘텐츠”</b>란 모든 아트워크, 타이틀, 테마, 개체, 캐릭터, 이름, 대화, 캐치프레이즈, 스토리, 애니메이션, 컨셉, 사운드, 오디오 비주얼 효과, 작동 방식, 음악적 구성, 가상 상품(제 9조에 정의됨) 및 본 '서비스' 내의 기타 콘텐츠를 의미합니다. 콘텐츠에는 모든 사용자(귀하 포함)가 '서비스' 내에서 '서비스'의 기능과 상호작용한 결과로 생성하거나 만들거나 달리 개발한 모든 것도 포함됩니다. 당사는 귀하에게 특정 '게임'의 게임 플레이 동영상을 만들 수 있는 제한적 라이선스도 부여하며, 그러한 라이선스는 모든 게임 플레이 동영상 활동에 별항 C-1의 당사 스트리밍 정책에 대한 귀하의 동의가 적용되며 그러한 활동이 이를 준수한다는 조건으로 '서비스'에 지정됩니다.  당사는 어떤 사유로든 단독 재량으로 모든 '콘텐츠'를 제거, 편집 또는 비활성화할 수 있습니다.</span></p>
                        
                        <p><span class="index">(b)</span><span>&nbsp;</span><u><span>귀하가 서비스 외부에서 생성한 콘텐츠. </span></u><span> <b>“사용자 콘텐츠”</b>란 귀하(또는 기타 '게임 계정' 소유자)가 '서비스' 외부에서 생성 또는 획득하여 귀하 또는 다른 사용자가 '서비스' 내에서 사용할 수 있도록 만든 모든 '콘텐츠'를 의미합니다. 명확하게 하기 위해 '콘텐츠'가 '서비스' 내에서 생성된 경우에는 '사용자 콘텐츠'가 아닙니다. '서비스' 외부에서 생성 또는 획득한 후 사용자가 '서비스' 내에서 사용하도록 제공한 '콘텐츠'만 '사용자 콘텐츠'에 해당합니다. '서비스'를 통해 '사용자 콘텐츠'를 제공함으로써 귀하는 '서비스' 및 '콘텐츠'를 운영하고 귀하 및 '서비스'의 다른 사용자에게 제공하는 것과 관련하여 귀하의 '사용자 콘텐츠'를 사용, 복사, 수정, 파생물 제작, 배포, 공개적으로 게시, 공개적으로 시연할 수 있는 하위 라이선스 권리와 함께 비배타적이고 양도 가능하며 전 세계적이고 로열티 없는 라이선스를 당사에 부여하게 됩니다. 법률에 의해 금지되는 범위를 제외하고 귀하는 “인격권” 또는 “저작 인격권” 또는 '사용자 콘텐츠'에 대해 국가에서 부여하는 유사한 권리의 편익을 포기합니다.  당사는 언제든, 어떤 이유로든 '사용자 콘텐츠'를 단독 재량으로 제거, 편집 또는 비활성화할 수 있으며, 여기에는 당사에서 '사용자 콘텐츠'가 본 '서비스 약관'을 위반한다고 판단하는 경우가 포함됩니다. 당사는 '사용자 콘텐츠'를 제거하거나 제거하지 않음으로 인한 책임 또는 의무 또는 다른 '콘텐츠'에 대한 책임 또는 의무를 부담하지 않습니다. 당사는 '사용자 콘텐츠'를 사전 검열하거나 검토하지 않으며, '서비스' 또는 당사의 기타 서비스에서 제공될 수 있는 모든 '사용자 콘텐츠'를 승인하거나 지지하지 않습니다.</span></p>
                        
                        <p><span class="index">(c)</span><span>&nbsp;</span><u><span>사용자의 거주지에 따른 서비스 제한. </span></u><span>당사는 귀하가 있는 지역에 따라 특정 '콘텐츠', '가상 상품', 전체 '게임', 또는 '서비스'의 일부 또는 전부를 제한 또는 수정하거나 이에 대한 귀하의 사용 및 액세스를 제한할 수 있습니다. 전술한 내용에 대한 제한 없이 '콘텐츠', '가상 상품', 전체 '게임' 또는 '서비스'가 거주 국가에서 적용되는 법률을 준수하지 않을 경우 귀하가 있는 지역에서는 이를 (전체적 또는 부분적으로) 사용할 수 없거나 수정된 버전으로만 사용할 수 있습니다.</span></p>
                        
                        <p><span class="index">(d)</span><span>&nbsp;</span><u><span>소매 구매. </span></u><span></span>당사는 '게임'에서 활성화할 수 있거나 '앱 스토어'에서 '게임'을 활성화하는 데 사용할 수 있는 코드 또는 제품 키를 제공할 수 있습니다. 귀하의 관할권에 해당하는 외환 관리 규정에 따라 그러한 코드 또는 키는 당사 또는 당사의 공인 소매업체를 통해 구매(또는 달리 합법적으로 획득)해야 유효합니다. 제3자로부터 그러한 코드 또는 키를 구매할 경우 그러한 코드 또는 키에 발생하는 모든 문제를 해결할 책임은 해당 제3자에게 있습니다. 관련 법률에 따라 당사는 제3자로부터 구매한 코드 또는 키에 대한 책임을 지지 않으며, 해당하는 외환 관리 규정을 위반하여 구매한 경우에도 책임을 지지 않습니다.</span></p>
                        
                        <p><span class="index">(e)</span><span>&nbsp;</span><u><span>최소 요구사항. </span></u><span>'게임'을 플레이하고자 하는 기기 및 시스템에 대한 최소 요구사항이 있을 수 있습니다. 당사는 해당하는 웹사이트에 최소 요구사항을 게시하거나 서면으로 달리 고지할 수 있습니다. 최적의 경험을 위해 '게임'을 플레이하기 전에 기기 및 시스템이 이러한 요구사항을 충족하도록 하십시오.</span></p>
                        
                        <p><span class="index">(f)</span><span>&nbsp;</span><u><span>발작 경고. </span></u><span> '게임'에는 특정 개인에게 간질 발작을 유발할 수 있는 깜박이는 빛, 이미지, 기타 발광 자극이 포함될 수 있습니다. 귀하 또는 가구 구성원에게 간질 질환이 있는 경우 '게임'을 플레이하기 전에 의사와 상의하십시오. 플레이 중 현기증, 시력 저하, 눈 또는 근육 경련, 의식 상실, 혼미, 불수의운동 또는 경련이 발생할 경우 즉시 '게임' 플레이를 중단하고 의사와 상의하십시오.</span></p>
                        
                        <p class="title-big"><b><span>7. 플레이어의 행위</span></b></p>
                        
                        <p><span>귀하는 당사에서 규정한 바에 따라 해당하는 경우 '서비스'와 관련해 다음 행위를 하지 않는다는 데 동의합니다.</span></p>
                        
                        <p><span class="index">(a)</span><span>&nbsp;</span><span>상업적, 홍보 목적 또는 제3자의 이익을 위한 목적 또는 본 '서비스 약관'에 허용되지 않는 방식으로 사용하는 행위</span></p>
                        
                        <p><span class="index">(b)</span><span>&nbsp;</span><span>'서비스'와 당사 간의 커뮤니케이션을 가로채거나 에뮬레이션하거나 리디렉션하는 무허가 제3자 프로그램 또는 '게임'에 관한 정보를 수집하는 무허가 제3자 프로그램을 사용 또는 제공하는 행위</span></p>
                        
                        <p><span class="index">(c)</span><span>&nbsp;</span><span>호스팅, 서비스 '레벨링', 당사 서버 미러링, 매치메이킹, 에뮬레이션, 커뮤니케이션 리디렉션, 모드, 핵, 치트, 봇(또는 기타 자동화된 컨트롤), '서비스'와 어떤 방식으로든 상호작용하는 트레이너 및 자동화 프로그램, 터널링, 제3자 프로그램 추가 기능, 온라인 또는 네트워크 플레이에 대한 방해 등 당사가 '서비스' 내에서 제공하지 않는 부수적인 제품/서비스(또는 앱 스토어의 기능)를 사용 또는 제공하는 행위</span></p>
                        
                        <p><span class="index">(d)</span><span>&nbsp;</span><span>한 번에 하나 이상의 기기에서 액세스하거나 사용하는 행위</span></p>
                        
                        <p><span class="index">(e)</span><span>&nbsp;</span><span>본 '서비스 약관'에서 명시적으로 승인하지 않은 방식으로 복사, 복제, 배포, 표시, 미러링, 프레이밍 또는 사용하는 행위(당사의 기타 자료, 지적 재산 또는 독점 정보 포함)</span></p>
                        
                        <p><span class="index">(f)</span><span>&nbsp;</span><span>'가상 상품', '게임 통화' 또는 '콘텐츠'에 대한 일명 '이차 시장'에 참여하거나 이를 운영하는 행위를 비롯해 '서비스', '게임' 또는 제한 없이 '가상 상품' 또는 '게임 통화'를 포함하는 모든 '콘텐츠'를 판매, 대여, 임대, 배포 또는 달리 양도하는 행위</span></p>
                        
                        <p><span class="index">(g)</span><span>&nbsp;</span><span>'서비스' 또는 '콘텐츠'를 기반으로 리버스 엔지니어링(관련 현지 법률에서 달리 허용되는 경우 제외)하거나 소스 코드를 도출하거나 수정, 적응, 변환, 데이터마이닝, 디컴파일 또는 디어셈블 또는 파생 작업물을 제작하려고 시도하는 행위</span></p>
                        
                        <p><span class="index">(h)</span><span>&nbsp;</span><span>당사가 '서비스' 또는 관련 지적 재산을 보호하기 위해 구현한 기술적 조치를 제거, 비활성화, 우회 또는 수정하는 행위</span></p>
                        
                        <p><span class="index">(i)</span><span>&nbsp;</span><span>온라인 또는 기타 게임 모드에서 이득을 얻기 위한 무단 소프트웨어 프로그램 또는 기타 치트(아래에 정의된 바에 따름)를 생성, 개발, 배포 또는 사용하는 행위</span></p>
                        
                        <p><span class="index">(j)</span><span>&nbsp;</span><span>취약점을 조사, 스캔 또는 테스트하려고 시도하거나 보안 또는 인증 조치를 침해하는 행위</span></p>
                        
                        <p><span class="index">(k)</span><span>&nbsp;</span><span>'서비스'의 비공개 영역에 액세스하거나 이를 변형 또는 사용하는 행위</span></p>
                        
                        <p><span class="index">(l)</span><span>&nbsp;</span><span>권한이 없는 부지 또는 위치에 무단 침입하거나 접근하려고 시도하는 행위 또는 부상, 사망, 재산 손해, 불법 방해 또는 기타 책임을 유발할 수 있는 활동에 참여하는 행위</span></p>
                        
                        <p><span class="index">(m)</span><span>&nbsp;</span><span>(i) 제3자의 특허, 저작권, 상표권, 영업 비밀, 계약상 권리, 인격권 또는 기타 지적 재산권, 퍼블리시티 또는 프라이버시권, 제3자의 기타 권리를 침해, 유용, 위반하는 내용, (ii) 관련 법률 또는 규정을 위반하거나 위반하는 행위를 독려하거나 민사 책임을 유발하는 내용, (iii) 사기 또는 거짓이거나 오도하거나 속이는 내용, (iv) 전적으로 유해하거나, 인종적 또는 도덕적으로 무례하거나, 폄하하거나, 불경스럽거나, 비방하거나, 명예를 훼손하거나, 음란하거나, 외설적이거나, 아동 성애와 관련이 있거나, 저속하거나, 공격적인 내용, (v) 개인 또는 집단에 대한 차별, 편견, 인종 차별, 증오, 괴롭힘 또는 피해를 장려하는 내용, (vi) 폭력적이거나 괴롭히거나 위협적인 내용 또는 폭력, 자금 세탁, 도박, 테러, 개인 또는 단체를 위협하거나 존중하지 않는 행위를 장려하는 내용, (vii) 어떤 방식으로든 미성년자에게 피해를 주는 내용, (viii) 불법적 또는 유해한 활동 또는 물질을 장려하는 내용에 해당하는 '사용자 콘텐츠'를 업로드, 게시, 제출 또는 전송하거나, 여기에 해당하는 사용자 이름 또는 계정 이름을 생성하거나 여기에 해당하는 행위에 달리 참여하는 행위</span></p>
                        
                        <p><span class="index">(n)</span><span>&nbsp;</span><span>(i) 관련 법률 또는 규정을 위반하거나 위반하는 행위를 독려하거나 민사 책임을 유발하는 행동, (ii) '트롤링'을 포함해 사기 또는 거짓이거나 오도하거나 속이는 행동, (iii) 명예를 훼손하거나 음란하거나 외설적이거나 저속하거나 공격적인 행동, (iv) 개인 또는 집단에 대한 차별, 편견, 인종 차별, 증오, 괴롭힘 또는 피해를 장려하는 행동, (v) '게임', '앱', 사용자 또는 사용자 커뮤니티를 방해하거나 폭력적, 괴롭힘 또는 위협적인 행동 또는 폭력, 테러 또는 개인이나 단체를 위협하거나 존중하지 않는 행위를 장려하는 행동, (vi)불법적 또는 유해한 활동 또는 물질을 장려하는 행동에 참여하는 행위</span></p>
                        
                        <p><span class="index">(o)</span><span>&nbsp;</span><span>사용자, 호스트 또는 네트워크의 액세스를 방해하거나 방해하려고 시도하는 행위, '서비스' 또는 사용자를 상대로 하는 바이러스 전송, 오버로딩, 플러딩, 스팸, 메일 폭탄을 포함하며 이에 국한되지 않음</span></p>
                        
                        <p><span class="index">(p)</span><span>&nbsp;</span><span>그 자체 또는 명시적인 동의 없이 다른 '서비스' 사용자의 '서비스'로부터 얻은 기타 정보와 결합하여 개인을 식별하는 데 사용할 수 있는 정보를 수집 또는 저장하는 행위</span></p>
                        
                        <p><span class="index">(q)</span><span>&nbsp;</span><span>다른 사용자가 당사의 의도대로 '서비스'를 즐기는 데 방해가 되는 방식으로 행동하는 경우, 당사의 단독 재량에 따라 괴롭힘, 악의적이거나 공격적인 언어의 사용, 게임 방치, 게임 사보타주, 스팸, 불쾌한 방식의 행동, 소셜 엔지니어링, 스캠, 공중 도덕 또는 공익 질서에 반하는 행위를 포함하되 이에 국한되지 않음</span></p>
                        
                        <p><span class="index">(r)</span><span>&nbsp;</span><span>개인 또는 법인과의 관련성을 사칭 또는 허위 진술하는 행위, 그러한 메시지의 출처에 관한 수신인을 속이거나 오도하는 행위 또는 그 성질이 전체적으로 공격적이거나 위협적인 정보를 전달하는 행위</span></p>
                        
                        <p><span class="index">(s)</span><span>&nbsp;</span><span> '서비스'의 지리적 제한을 우회할 목적 또는 그 외 다른 목적으로 IP 프록싱 또는 행위 거주 지역을 위장하는 다른 방법을 사용하는 행위</span></p>
                        
                        <p><span class="index">(t)</span><span>&nbsp;</span><span>'게임 계정'의 상태, 레벨, 순위를 '높이기' 위해 타인의 '게임 계정'으로 플레이하는 행위</span></p>
                        
                        <p><span class="index">(u)</span><span>&nbsp;</span><span>당사에 부정적으로 영향을 미치거나 당사 또는 '서비스'를 부정적으로 반영하거나 '서비스' 기능의 전부 또는 일부를 사용하지 않도록 권장하는 방식으로 '서비스'를 사용하는 행위</span></p>
                        
                        <p><span class="index">(v)</span><span>&nbsp;</span><span>전술한 내용을 타인에게 장려 또는 홍보하거나 이러한 행위에 참여시키거나 이를 지원하는 행위</span></p>
                        
                        <p><span class="index">(w)</span><span>&nbsp;</span><span>관련 법률 또는 규정을 위반하는 행위</span></p>
                        
                        <p><span>이러한 규정을 위반하는 다른 사용자를 목격할 경우 관련 '게임' 또는 '서비스'에서 '악용 신고' 기능을 사용하여 당사에 해당 활동을 신고하거나(해당하는 경우), support@sfduelmobile.zendesk.com으로 문의해 주십시오.</span></p>
                        
                        <p class="title-big"><b><span>8. 서비스의 소유권</span></b></p>
                        
                        <p><span>당사 및 당사의 계열사, 라이선스 부여자는 '서비스'에 대한 모든 권한, 소유권, 지적 재산권을 소유합니다. 귀하는 '서비스'에 포함되거나 수반되는 저작권, 상표, 서비스 마크 또는 기타 독점 권리 고지를 제거 또는 변형하거나 모호하게 만들지 않는다는 데 동의합니다.  귀하는 귀하에게 '서비스' 또는 '게임' 또는 '콘텐츠'에 대한 소유권 관련 이해 관계가 없다는 사실을 이해하고 이에 동의합니다. '서비스'(및 특히 당사의 '게임')에는 한 사용자에게 다른 사용자에 대비한 이득을 불공정하게 부여하지 않도록 만들어진 메커니즘이 내장되어 있을 수 있습니다(이러한 행위는 <b>“치팅”</b>이며 이러한 소프트웨어를 <b>“치트 감지 소프트웨어”</b>라고 함). 당사는 당사의 단독 재량에 따라 필요한 경우 '치트 감지 소프트웨어'를 추가하거나 정기적으로 업데이트할 수 있습니다. '서비스' 및/또는 '치트 감지 소프트웨어'에서는 귀하의 '게임 계정', 게임 플레이 및 '치팅'과 관련된 무단 프로그램 또는 프로세스에 관한 세부정보를 수집 및 전송할 수 있으며, 여기에는 당사의 개인정보처리방침과 관련 법률이 적용됩니다. 당사가 당사의 단독 재량으로 귀하가 '치팅'한다는 결론을 도출할 경우 귀하는 당사가 본 '서비스 약관' 및 당사 '서비스'에 대한 귀하의 액세스 종료를 비롯해 본 '서비스 약관'에 따른 당사의 모든 권리를 행사할 수 있음에 동의합니다. 또한 귀하가 하나의 '게임' 또는 '서비스'에서 '치팅'하는 경우에도 당사는 당사의 모든 '게임' 및 '서비스'를 사용할 수 있는 귀하의 라이선스를 종료할 수 있습니다.</span></p>
                        
                        <p><span>당사는 '서비스' 액세스 또는 사용을 모니터링하거나 '콘텐츠'를 검토 또는 편집할 의무가 없지만 '서비스' 운영 및 게시, 본 '서비스 약관'의 준수, 위협을 받을 수 있는 모든 사람의 건강 또는 안전 보호, 당사의 법적 권리 및 구제 조치 보호, 범죄 또는 공격적 행동의 신고, 관련 법률의 준수 목적으로 그리할 권리를 보유합니다. 당사는 언제든 고지 없이 '콘텐츠'에 대한 액세스 권한을 제거하거나 비활성화할 수 있습니다(그러나 그리할 의무는 없음). 당사는 본 '서비스 약관'의 위반 또는 '서비스'에 영향을 미치는 행위를 조사할 수 있습니다(그러나 그리할 의무는 없음).</span></p>
                        
                        <p class="title-big"><b><span>9. 가상 상품 및 게임 통화</span></b></p>
                        
                        <p><span class="index">(a)</span><span>&nbsp;</span><u><span>가상 상품 및 게임 통화의 구매 또는 획득.</span></u><span>귀하의 관할권에 적용되는 관련 외환 관리 규정에 따라 당사는 당사 '게임' 내에서 귀하가 실제 통화로 구매할 수 있는 특정 업그레이드 및 옵션을 제공할 수 있으며, 관련 법률에 따라 허용되는 게임 내 통화(이하 <b>“게임 통화”</b>), 캐릭터 스킨, 마운트 및 차량, 디지털 카드, 경험치 부스트, 기어 및 기타 게임 내 캐릭터 맞춤 설정, 귀하의 '게임' 경험을 어떤 방식으로든 개선할 수 있는 기타 디지털 추가 기능 아이템(이하 <b>“가상 상품”</b>)을 포함하되 이에 국한되지 않습니다. '게임'의 기능 내에서 달리 전달되는 경우를 제외하고 '게임 통화' 및 '가상 상품'은 한 '게임'에서 다른 '게임'으로 이전할 수 없습니다. 또한 귀하는 게임 내 어워드와 같이 특정 '가상 상품' 및 '게임 통화'를 구매하지 않고 획득할 수도 있습니다. 귀하가 '게임 통화', '가상 상품' 또는 '게임' 자체를 구매하는 경우(각각 <b>“거래”</b>), 귀하의 구매는 '앱 스토어' 또는 당사가 귀하에게 제공하는 기타 플랫폼을 통해 사용할 수 있는 기능으로 이루어집니다. '거래'를 수행하기 전에 귀하는 해당 계약이 '앱 스토어 계약'이든 다른 플랫폼 계약이든 '거래'에 적용되는 계약을 완전히 이해해야 합니다. 귀하가 '가상 상품' 또는 '게임 통화'를 구매하거나 기타 '거래' 양상에 참여할 수 있는 수량과 횟수에 제한이 있을 수 있습니다. 예를 들어, 귀하가 특정 시점에 (게임 내에서) 보유하거나 구매할 수 있는 '게임 통화'의 최대 양 또는 귀하가 하루에 수행할 수 있는 '거래'의 최대 횟수가 있을 수 있으며, 이러한 추가적인 제한은 '서비스'의 기능을 통해 전달될 수 있습니다. 당사는 '게임 통화', '가상 상품', 구매에 적용되는 당사의 수수료, 결제 방법, 약관을 수시로 수정, 개정 또는 보충할 수 있으며, 본 '서비스 약관'에 대한 변경사항은 별도의 이용 약관 또는 관련 웹사이트에 게시된 기타 약관에 게시하거나 '게임'의 일부로 제공하거나 당사가 귀하에게 달리 전달합니다. 귀하의 관할권에서 법률에 의해 금지되는 경우를 제외하고 그러한 수정, 개정, 보충 또는 약관은 게시 즉시 효력을 발휘하며 본 '서비스 약관'에 참조로 통합되어야 합니다. 변경사항을 수락할 수 없는 경우 귀하는 언제든 '게임 계정'의 사용을 종료할 수 있습니다.</span></p>
                        
                        <p><span class="index">(b)</span><span>&nbsp;</span><u><span>가상 상품 및 게임 통화에 대한 귀하의 라이선스.</span></u><span>'가상 상품' 및 '게임 통화'는 디지털 아이템이며 이에 대한 귀하의 사용에는 본 '서비스 약관'과 '앱 스토어 계약'이 적용됩니다.  가상 상품 및 게임 통화에는 금전적 가치가 없으며 현금으로 교환할 수 없습니다. 가상 상품은 전부 또는 일부를 양도 및 거래할 수 없으며, 투자 목적으로 제공되지 않습니다. '가상 상품' 및 '게임 통화'는 판매되는 것이 아니라 라이선스가 부여되는 것입니다. 귀하가 이 '서비스 약관' 및 '앱 스토어 계약'의 조항을 준수하는 경우 당사는 귀하에게 개인적이고 비배타적이며 양도 및 하위 라이선스가 불가하고 제한적인 권리와 귀하가 구매하거나 다른 방식을 통해 획득한 액세스 권한이 있는 '가상 상품' 또는 '게임 통화'를 다른 목적이 아닌 관련 '게임'의 사용을 위해 해당 '게임' 내에서만 사용할 수 있는 라이선스(당사가 여러 '게임'에서 사용할 수 있다고 달리 전달하지 않는 한)를 부여합니다.  특정 '게임'에서 당사가 명시적으로 허용하지 않는 한 귀하는 이러한 '가상 상품' 또는 '게임 통화'를 다른 사용자와 거래할 수 없습니다. 무단 또는 사기 활동이 의심되는 경우 또는 귀하의 '계정'에 잘못 적용된 '가상 상품'이나 '게임 통화'를 수정할 목적으로 당사는 '가상 상품' 또는 '게임 통화'의 사용을 취소, 무효화 또는 다른 방식으로 방지할 수 있습니다.</span></p>
                        
                        <p><span class="index">(c)</span><span>&nbsp;</span><u><span>게임 통화 및 가상 상품의 변경.</span></u></span>관련 법률에 의해 달리 금지되는 경우를 제외하고 당사는 당사가 업데이트를 위해 '게임'을 일시 중지해야 하는 경우, '서비스'를 비활성화해야 하는 긴급 상황 또는 시간이 지날수록 온라인 사용을 지속하는 사용자 수가 제한되어 경제적 또는 기타 사유로 '게임'을 결국 중단해야 하는 경우 등에 당사의 단독 재량으로 귀하에 대한 통지 또는 책임 없이 '게임 통화' 또는 '가상 상품'에 대한 액세스 또는 사용 기능을 포함해 '게임 통화' 또는 '가상 상품'을 수정, 대체, 교체, 일시 중지, 취소 또는 삭제할 수 있습니다. 귀하는 당사, 당사의 계열사, 임직원, 대리인 또는 라이선스 부여자(이하 <b>“기업 당사자”</b>)를 상대로 (a) 귀하에게 게임 통화 또는 가상 상품에 대해 독점적 이해가 있다는 소송, (b) (i) 계정의 삭제 또는 일시 중지, (ii) 가상 상품 또는 게임 통화의 가치 변경으로 인해 발생한 게임에 대한 조정, (iii) 본 서비스 약관의 수정, 종료, 만료로 인해 손실된 것으로 주장하는 게임 통화 또는 가상 상품의 금전적 가치에 대한 소송을 주장하거나 제기하지 않는다는 데 동의합니다.</span></p>
                        
                        <p class="title-big"><b><span>10. 환불</span></b></p>
                        
                        <p><span>관련 법률(아래의 각 국가별 부록에 설명된 내용 포함) 또는 '앱 스토어' 정책에 따라 (i) 모든 '게임', '가상 상품' 및 '게임 통화'는 당사의 자산으로 남아 있으며, 금전적 가치를 갖지 않고, 결함이 있거나 사용할 수 없거나 당사가 제공된 사양에 따라 작동하지 않는 경우를 제외하고는 교환, 환불 또는 “실제” 금전 또는 금전적 가치가 있는 것을 위한 다른 구제책의 대상이 될 수 없고, (ii) 당사는 귀하에 대한 통지 또는 책임 없이 본 '서비스 약관'에 따라 언제든 그러한 '게임', '가상 상품' 및/또는 '게임 통화'에 대한 귀하의 라이선스를 취소할 수 있으며, (iii) 관할권의 법률에 따라 계약에 의해 포기할 수 없는 철회권이 부여되는 경우를 제외하고 '게임', '가상 상품' 및/또는 '게임 통화'를 구매 및 사용함으로써 귀하는 관련 '게임', '가상 상품' 및/또는 '게임 통화' 구매를 위해 동의 철회에 대한 권리를 포기하고 따라서 그러한 '게임', '가상 상품' 및/또는 '게임 통화'와 관련해 환불(또는 기타 구제책)을 받을 수 없다는 데 동의합니다. 또한 귀하는 관할권의 법률에서 달리 규정하지 않는 한 '게임', '가상 상품' 및/또는 '게임 통화'를 구매하고 전달 받는 즉시 모든 철회권이 만료된다는 데 동의합니다. 본 항은 귀하의 법적 권리에 영향을 미치지 않습니다.</span></p>
                        
                        <p class="title-big"><b><span>11. 베타 테스팅</span></b></p>
                        
                        <p><span>당사는 수시로 당사 '서비스' 중 하나의 베타 버전(이하 <b>“베타”</b>)을 제공할 수 있습니다. 이름에서 알 수 있듯 베타는 상업적 출시 버전이 아니며 적절한 작동이 보장되지 않고 시스템의 다른 부분이 적절하게 작동하지 않게 만들 수 있습니다. 위의 6항에 따라 귀하에게 베타로 연장할 수 있는 라이선스가 부여된 경우(즉, 귀하에게 베타를 사용할 권한이 있는 경우) 귀하는 이 '서비스 약관'의 나머지 부분 이외에 다음 조항을 확인하고 이에 동의합니다.</span></p>
                        
                        <p><span class="index">(a)</span><span>&nbsp;</span><span>당사는 '베타' 테스트 기간 중 언제든 어떤 사유로든 귀하의 컴퓨터에 저장된 '베타'와 관련된 정보를 자동으로 삭제하거나 수정할 수 있습니다.</span></p>
                        
                        <p><span class="index">(b)</span><span>&nbsp;</span><span>당사는 언제든 '베타' 테스트를 종료할 수 있으며, 이후에는 '베타'가 플레이 또는 제대로 기능할 수 없게 됩니다. 당사가 '베타'를 종료할 경우 귀하는 컴퓨터에 있는 로컬 '베타' 인스턴스와 '베타'와 관련해 받은 모든 문서 및 자료를 삭제해야 합니다.</span></p>
                        
                        <p><span class="index">(c)</span><span>&nbsp;</span><span>'베타' 사용 시에는 해당 '베타' 및 모든 요소를 기밀로 취급해야 합니다. "기밀 정보"란 '베타'와 관련해 당사가 귀하에게 공개한 정보 또는 귀하가 액세스 또는 제공한 정보를 의미합니다(제공된 의견 및 '게임' 자체 포함). 귀하는 다음에 동의합니다.</span></p>
                        
                        <p style="text-indent:20.0pt;mso-outline-level:3;"><span>(i)</span><span>&nbsp;</span><span>본 '서비스 약관'에 따라 '베타'를 사용하는 데 필요한 경우를 제외하고 모든 '기밀 정보'를 사용하지 않습니다.</span></p>
                        
                        <p style="text-indent:20.0pt;mso-outline-level:3"><span>(ii)</span><span>&nbsp;</span><span>'기밀 정보'를 엄격한 기밀로 유지하고 귀하가 본인의 기밀 정보를 보호하는 데 기울이는 것과 동일한 수준의 주의를 기울이되, 어떤 상황에서도 합당한 수준 이하의 주의를 기울이지 않습니다.</span></p>
                        
                        <p style="text-indent:20.0pt;mso-outline-level:3;"><span>(iii)</span><span>&nbsp;</span><span>당사에서 허용하는 사람 또는 법인 이외의 사람 또는 법인에는 '기밀 정보'를 공개하지 않습니다.</span></p>
                        
                        <p style="text-indent:20.0pt;mso-outline-level:3;"><span>(iv)</span><span>&nbsp;</span><span>당사의 단독 재량으로 부여 또는 철회할 수 있는 당사의 사전 서면 승인 없이 '베타'와 관련된 정보를 게시 또는 공개(예: 스크린샷 및 사양)하는 등 '베타' 또는 '서비스'와 관련해 공개적으로 발표하지 않습니다. </span></p>
                        
                        <p><span class="index">(d)</span><span>&nbsp;</span><span>당사가 '베타'를 종료하더라도 이는 어떠한 종류의 환불에 대한 근거도 되지 않으며, '베타'에 대한 참여로 인해 '콘텐츠', '게임 통화' 등의 보상 또는 무료 '서비스'에 대한 권한이 부여되지 않습니다.</span></p>
                        
                        <p><span>특정 '게임'의 전체(비 '베타') 버전이 출시될 경우 당사는 귀하가 '게임'을 사용하여 전체 버전을 계속 진행하도록 허용할 수 있습니다. 당사에서 그리 허용하는 경우 귀하가 '게임'을 계속 사용하는 데는 본 11항이 더 이상 적용되지 않지만 본 '서비스 약관'의 나머지 부분은 계속 적용됩니다.</span></p>
                        
                        <p class="title-big"><b><span>12. 앱 스토어, 콘솔 게임</span></b></p>
                        
                        <p><span>'게임'이 '앱 스토어'(모바일 기기 또는 콘솔)를 통해 귀하에게 제공될 경우 귀하는 그러한 '게임'과 관련하여 별항 B-1의 조항을 확인하고 이에 동의합니다.</span></p>
                        
                        <p class="title-big"><b><span>13. 의견</span></b></p>
                        
                        <p><span>당사는 '서비스' 개선에 대한 귀하의 의견, 댓글 및 제안(이하 <b>“의견”</b>)을 환영합니다. support@sfduelmobile.zendesk.com으로 당사에 이메일을 보내거나 '서비스'의 기능(제공되는 경우)을 통해 '의견'을 제출할 수 있습니다. 귀하가 당사에 '의견'을 제공할 경우 이에 귀하는 어떤 국가에서, 어떤 목적으로도 의견을 사용, 복사, 수정, 파생물 제작, 사본 배포, 공개적으로 실연, 공개적으로 게시 및 달리 활용할 수 있도록 귀하가 소유 또는 통제하는 모든 지적 재산권에 따라 하위 라이선스할 수 있는 권리와 함께 비배타적이고 양도 가능하며 전 세계적이고 영구적이고 취소 불가능하며 관련 비용이 모두 지불되고 로열티가 없는 라이선스를 당사에 부여하게 됩니다. 이 라이선스는 당사가 1년의 기간 내에 이 라이선스에 따른 당사의 권리를 행사하지 않더라도 경과하거나 만료되지 않습니다. 관련 법률에 따라 당사에 라이선스를 부여할 수 없는 권리가 '의견'에 포함되어 있는 경우(예: 인격권 및 기타 인적 권리) 귀하는 그러한 권리를 포기하며 행사하지 않는다는 데 동의합니다. 귀하는 귀하가 자유롭게 '의견'을 제공하는 것이며, 당사가 그것을 사용할 필요가 없고, 귀하는 '의견'에 대해 어떤 식으로든 보상을 받지 않는다는 사실을 이해하고 이에 동의합니다. 귀하는 귀하가 당사에 제공하는 '의견'에 대해 당사와 기타 영향을 받는 당사자에게 위에 설명된 권리(지적 재산권이나 퍼블리시티권 또는 프라이버시권을 포함하되 이에 국한되지 않음)를 부여하기에 충분한 권리를 가지고 있음을 진술하고 보증합니다.</span></p>
                        
                        <p><span>그러한 '의견'을 게시함에 있어 귀하는 귀하의 의견이 이 '서비스 약관'을 준수한다는 사실을 보증하고 저속하거나 공격적인 언어를 사용하거나, 명예를 훼손하거나 악의적이거나 혐오적이거나 타인의 프라이버시를 침해하거나 다른 사용자에게 유해하거나 관련 법률을 위반하는 자료 또는 그럴 가능성이 있는 자료를 제출하지 않는다는 사실을 보증합니다.</span></p>
                        
                        <p class="title-big"><b><span>14. DMCA/저작권 정책</span></b></p>
                        
                        <p><span>당사는 저작권법을 준수하며 당사 사용자도 그러하기를 기대합니다. 적절한 상황에서 저작권 소유자의 권리를 반복적으로 침해하거나 반복적으로 침해하는 것으로 여겨지는 사용자의 '게임 계정'을 종료하는 것이 당사의 정책입니다.</span></p>
                        
                        <p class="title-big"><b><span>15. 제3자 웹사이트 및 리소스</span></b></p>
                        
                        <p><span>'서비스'에는 제3자 웹사이트 또는 리소스에 대한 링크가 포함될 수 있습니다. 당사는 이러한 링크를 편의로만 제공하며, 해당 웹사이트 또는 링크 또는 해당 웹사이트에 표시된 링크를 통해 이용할 수 있는 콘텐츠, 제품 또는 서비스에 대한 책임을 지지 않습니다. 귀하는 제3자 웹사이트 또는 리소스의 사용에 대한 단독 책임을 인정하며 이로 인해 발생하는 모든 위험을 감수합니다.</span></p>
                        
                        <p class="title-big"><b><span>16. 데이터 요금 및 모바일 기기</span></b></p>
                        
                        <p><span>귀하는 당사 '서비스' 사용으로 인해 부과될 수 있는 모든 데이터 관련 요금을 부담하며 이는 모바일, 텍스트 메시지, 데이터 요금을 포함하되 이에 국한되지 않습니다. 귀하는 '서비스'를 사용하기 전에 부과될 수 있는 요금에 관해 파악하거나 서비스 제공업체에 문의해야 합니다.</span></p>
                        
                        <p class="title-big"><b><span>17. 서비스 및 수정</span></b></p>
                        
                        <p><span>당사는 당사가 필요하다고 판단할 때마다 언제든 본 '서비스 약관'을 업데이트할 수 있습니다(그러나 반드시 그래야 하는 것은 아님). 관련 법률에 따라 업데이트한 경우 귀하가 다음 번에 '서비스'에 액세스하거나 업데이트된 '서비스 약관'이 다른 방식으로 귀하에게 전달될 때 업데이트된 '서비스 약관'에 대한 동의를 요청하는 메시지가 귀하에게 표시됩니다. '서비스'를 계속 사용하려면 귀하는 업데이트에 반드시 동의해야 합니다.</span></p>
                        
                        <p><span>당사는 귀하가 '서비스'를 계속 사용하려면 반드시 설치해야 하는 '서비스'에 대한 패치, 업데이트 또는 업그레이드를 제공할 수 있습니다. 당사는 귀하에게 통지하지 않고 원격으로 '서비스'를 업데이트할 수 있으며 이에 귀하는 패치, 업데이트, 업그레이드 등을 적용함으로써 당사에 동의하게 됩니다. 귀하의 기기에서 자동 업데이트를 방지할 수 있는 경우 귀하가 직접 기기에서 '서비스'를 업데이트할 때까지 '서비스'에 액세스하지 못하게 될 수 있습니다. 당사는 언제든 '서비스'의 특정 측면에 대한 귀하의 액세스 권한을 수정, 일시 중지, 중단, 대체, 교체 또는 제한할 수 있습니다. 관련 법률에 따라 귀하는 캐릭터 데이터, 게임 진행 상황, 게임 맞춤 설정 또는 특정 '게임' 및 '서비스'에 고유한 기타 요소의 사용과 관련된 기타 데이터를 당사의 통지 없이 언제든 사용할 수 없게 될 수 있다는 사실을 확인하며, 이는 당사에서 패치, 업데이트 또는 업그레이드를 적용한 이후를 포함하되 이에 국한되지 않습니다. 귀하는 '서비스'와 관련해 당사에 유지 관리 또는 지원 의무가 없다는 사실에 동의합니다.</span></p>
                        
                        <p><span>관련 법률에 따라 당사는 '서비스', '게임', '가상 상품', '게임 통화' 또는 '콘텐츠'의 가격을 언제든 어떤 사유로든 귀하에 대한 통지 또는 책임 없이 변경할 수 있습니다.</span></p>
                        
                        <p class="title-big"><b><span>18. 보증 부인 정보</span></b></p>
                        
                        <p><span>법률에 의해 허용되는 최대 범위까지 서비스는 어떤 종류의 보증도 없이 '있는 그대로' 제공됩니다. 전술한 내용에 국한되지 않고 기업 당사자는 상품성, 특정 목적 적합성, 향유권 및 비침해에 대한 묵시적 보증 및 거래 과정 또는 상관습으로 인해 제기된 모든 보증을 명시적으로 부인합니다. '기업 당사자'는 '서비스'가 귀하의 요구사항을 충족하거나 중단 없이 안전하게 또는 오류 없는 상태로 사용할 수 있음을 보증하지 않습니다. '기업 당사자'는 '서비스'의 품질, 정확성, 적시성, 진실성, 완전성 또는 안정성과 관련하여 어떠한 보증도 하지 않습니다.</span></p>
                        
                        <p class="title-big"><b><span>19. 책임의 제한</span></b></p>
                        
                        <p><span>관련 법률에서 허용하는 최대한의 범위 내에서 기업 당사자는 다음에 관한 책임을 어떤 식으로든 부담하지 않습니다.</span></p>
                        
                        <p><span class="index">(a)</span><span>&nbsp;수익의 손실,</span></p>
                        
                        <p><span class="index">(b)</span><span>&nbsp;</span><span>손실된 수입,</span></p>
                        
                        <p><span class="index">(c)</span><span>&nbsp;</span><span>손실된 절감액.</span></p>
                        
                        <p><span class="index">(d)</span><span>&nbsp;</span><span>데이터의 손실 또는</span></p>
                        
                        <p><span class="index">(e)</span><span>&nbsp;</span><span>모든 간접적, 부수적, 결과적, 특수한 또는 징벌적 손해,</span></p>
                        
                        <p><span>본 서비스 약관 또는 서비스 또는 서비스의 기능 지연 또는 사용 불가 또는 지연으로 인해 또는 이와 관련하여 발생하는 손해, 일방 기업 당사자가 그러한 손해의 가능성에 대해 알림을 받았음에도 불구하고 해당 일방 기업 당사자의 잘못, 불법 행위(과실 포함), 엄격한 책임, 배상, 제조물 책임, 계약 위반, 보증 위반 등이 있는 경우.  또한 관련 법률에서 허용하는 최대한의 범위 내에서 본 서비스 약관 또는 서비스로 인해 또는 이와 관련하여 발생하는 기업 당사자의 총 책임은 다음을 초과하지 않습니다. (a) 그러한 책임이 발생한 사건 직전 육(6)개월 중 문제의 특정 게임 또는 서비스를 위해 귀하가 당사에 지불했거나(있는 경우) 지불할 수 있는 총액, (b) (a)가 적용되지 않는 경우 미화 50달러 손해 배상과 관련된 이러한 제한 및 예외는 구제책으로 적절한 보상이 제공되지 않고 구제책이 귀하와 당사 간 협상의 기반이 되는 기본적인 요소인 경우에도 적용됩니다.</span></p>
                        
                        <p><span>전술한 내용에도 불구하고 일부 국가, 주, 지방 또는 기타 관할권에서는 위에서 서술한 바와 같은 특정 보증의 예외 또는 책임의 제한을 허용하지 않으므로 위의 조항이 귀하에게 적용되지 않을 수 있습니다. 대신 그러한 관할권에서는 전술한 예외 및 제한이 그러한 관할권의 법률에 따라 허용되는 최대 범위까지 적용됩니다. 또한 귀하는 관할권에서 추가적인 법적 권리를 보유할 수 있으며, 본 '서비스 약관'의 어떠한 내용도 '서비스'의 소비자로서 귀하가 가질 수 있는 그러한 권리를 침해하지 않습니다.</span></p>
                        
                        <p class="title-big"><b><span>20. 면책</span></b></p>
                        
                        <p><span>귀하는 (a) 귀하의 '서비스' 액세스 또는 사용, (b) 본 '서비스 약관'의 위반을 구성하는 주장(사실인 경우)으로 인해 또는 어떤 식으로든 이와 관련하여 발생하는 모든 소송, 요구, 법적 조치, 손실, 책임 및 비용(변호사 수수료, 비용, 전문가 증언 수수료를 포함하되 이에 국한되지 않음)으로부터 '기업 당사자' 및 그 임직원, 대리인, 계약업체 및 기타 담당자에게 배상(즉, 발생한 모든 손실에 대한 보상), 변호사 비용, 면책을 제공하는 데 동의합니다. 귀하는 제 20항이 적용되는 모든 사안에 근거하여 법원 판결인지, 합의인지 여부와 무관하게 당사가 부담한 지불액 또는 손실을 당사에 상환하는 데 동의합니다.</span></p>
                        
                        <p class="title-big"><b><span>21. 종료</span></b></p>
                        
                        <p><span>(a) 당사가 일반적으로 비슷한 상황에 있는 사용자에 대한 '게임' 제공을 중단하는 경우 (b) 귀하가 본 '서비스 약관'('앱 스토어 약관 및 본 '서비스 약관'에 지정된 기타 정책 포함)을 위반하는 경우 (c) 관련 '앱 스토어'의 소유자가 귀하의 '앱 스토어 계정'을 종료하는 경우 또는 (d) 당사가 '서비스'에 대한 귀하의 액세스 또는 사용을 일시 중지 또는 수정하거나 당사의 단독 재량으로 본 '서비스 약관'을 종료하는 것이 필요하다고 달리 간주하는 경우 관련 법률에 부합하는 최대 한도 내에서 당사는 귀하에 대한 책임 또는 통지 없이 '게임', '가상 상품', '콘텐츠' 등 '서비스'에 대한 액세스 및 사용을 중지, 수정 또는 종료할 수 있습니다. 귀하는 모든 기기에서 '게임'을 삭제 및 제거하거나 '앱 스토어 계정'을 삭제하여 본 '서비스 약관'을 종료할 수도 있습니다.  '서비스'에 대한 귀하의 액세스 및 사용을 일시 중지하거나 수정할 경우 당사의 단독 재량에 따라 결정된 대로 귀하는 '서비스'의 일부 또는 모든 기능에 액세스하거나 이를 사용할 수 없게 됩니다. 본 '서비스 약관' 종료 시 귀하에게 부여된 권리는 자동으로 종료되며 귀하는 더 이상 이러한 권리 또는 본 '서비스 약관'을 행사할 수 없습니다.  관련 법률에 따라 당사는 당사의 단독 재량에 따라 그러한 종료 이후에도 '서비스'에 대한 액세스 및 사용을 지속할 수 있습니다.</span></p>
                        
                        <p><span>관련 법률에 의해 요구되는 경우 이러한 '서비스 약관'의 종료에는 종료에 영향을 미치는 법원 결정 또는 종료의 전제 조건으로 법원 집달관이 게시하는 통지가 필요하지 않습니다.</span></p>
                        
                        <p><span>법률에서 요구하는 범위를 제외하고 모든 결제 및 수수료는 본 '서비스 약관'의 종료 여부와 관계 없이 어떠한 경우에도 환불 불가합니다.</span></p>
                        
                        <p><span>다음 조항은 본 '서비스 약관' 종료 시에도 존속합니다. 8 (첫 두 문장만 해당), 13, 19, 20, 22 ~ 25 및 제 21항의 본 문장.</span></p>
                        
                        <p class="title-big"><b><span>22. 분쟁 해결 및 준거법</span></b></p>
                        
                        <p><span>국제 사법의 조항과 관련 없이 본 '약관' 및 이에 따른 관련 조치에는 중화인민공화국의 법률이 적용됩니다. 본 '약관'으로 인해 또는 본 정책과 관련하여 발생하는 모든 분쟁은 홍콩 국제 중재 센터("HKIAC")에 중재를 위해 제출되어야 하며, 중재를 신청한 시점의 HKIAC 중재 규칙에 따라 중재가 이루어져야 합니다. 중재 장소는 홍콩입니다. 중재 절차에 사용되는 언어는 영어입니다. 중재 결정은 최종적이며 양 당사자에게 구속력이 있습니다.</span></p>
                        
                        <p class="title-big"><b><span>23. 양도 금지</span></b></p>
                        
                        <p><span>귀하는 당사의 사전 서면 동의 없이 법률 시행에 의해 또는 다른 방식으로 본 '서비스 약관'을 양도 또는 이전할 수 없습니다. 그러한 동의 없이 본 '서비스 약관'을 양도 또는 이전하려는 시도는 무효입니다. 본 항의 표제에도 불구하고 당사는 본 '서비스 약관'을 제한 없이 자유롭게 양도 또는 이전할 수 있습니다. 전술한 내용에 따라 본 '서비스 약관'은 당사자의 이익, 후속 법인 및 허용된 양도에 대해 구속력을 갖고 효력을 발휘합니다.</span></p>
                        
                        <p class="title-big"><b><span>24. 기타</span></b></p>
                        
                        <p><span  class="index">(a)</span><span>&nbsp;</span><u><span>완전 합의.</span></u>&nbsp;<span>본 '서비스 약관' 및 본 '서비스' 약관에서 언급하는 기타 문서 또는 정보는 '서비스'와 관련하여 귀하와 당사 간의 완전하고 배타적인 이해를 구성하며 '서비스'와 관련하여 귀하와 당사 간에 있었던 모든 기존의 구두 또는 서면 양해 또는 계약에 우선합니다.</span></p>
                        
                        <p><span class="index">(b)</span><span>&nbsp;</span><u><span>언어.</span></u>&nbsp;</span>본 '서비스 약관'의 원어는 영어이며, 번역은 참고용으로만 제공됩니다. 관련 법률에 의해 허용되는 최대 범위까지 귀하는 거주 국가의 법률에 따라 본 '서비스 약관'이 다른 언어로 작성 또는 해석되기 위해 귀하가 보유할 수 있는 모든 권리를 포기합니다.</span></p>
                        
                        <p><span class="index">(c)</span><span>&nbsp;</span><u><span>가분성.</span></u>&nbsp;</span><span>본 '서비스 약관'은 특정한 법적 권리를 설명합니다. 귀하는 관할권의 법률에 따라 다른 권리를 보유할 수 있습니다. 관할권의 법률에서 허용하지 않는 경우 본 '서비스 약관'은 관할권의 법률에 따른 귀하의 권리를 변경하지 않습니다. 위에 언급된 바와 같이 특정 상황에서는 관할권에서 허용하지 않을 수 있으므로 본 '서비스 약관'의 보증 및 구제책의 제한 및 배제는 귀하에게 적용되지 않을 수 있습니다. 관련 관할권의 법원 또는 재판소에서 본 '서비스 약관'의 특정 조항을 시행 불가한 것으로 판단할 경우 그러한 조항은 관련 법률에 따라 가능한 최대 범위까지만 시행되며 본 '서비스 약관'의 나머지 조항은 완전한 효력을 유지합니다.</span></p>
                        
                        <p><span class="index">(d)</span><span>&nbsp;</span><u><span>권리 포기 부인.</span></u>&nbsp;<span>본 '서비스 약관' 내에 명시적으로 작성된 경우를 제외하면 본 '서비스 약관' 하에서는 귀하 또는 당사의 작위 또는 부작위로 인해 어떠한 권리도 발생하지 않습니다. 당사가 이 '서비스 약관'의 권리 또는 조항을 시행하지 못하더라도 이는 그러한 권리 또는 조항의 포기로 간주되지 않습니다. 그러한 권리 또는 조항의 포기는 서면으로 작성되고 정당한 권한을 부여 받은 대리인 중 한 명에 의해 서명된 경우에만 유효합니다. 이 '서비스 약관'에 명시적으로 규정된 경우를 제외하고 본 '서비스 약관'에 따른 각 당사자의 구제책 행사는 본 '서비스 약관'에 따른 다른 구제책 등을 침해하지 않습니다.</span></p>
                        
                        <p><span class="index">(e)</span><span>&nbsp;</span><u><span>귀하의 지위.</span></u>&nbsp;<span>귀하는 다음에 해당하는 인물이거나 다음에 해당하는 인물을 대신하여 행동하지 않습니다.</span></p>
                        
                        <p style="margin-bottom:10.0pt;"><span>a.</span><span>&nbsp;&nbsp;&nbsp;</span><span>국제 연합, 중화인민공화국, 미국(예: 특별지정 제재 대상 및 차단 인사 목록(“SDN 목록”) 또는 법인 목록), 국제 연합 안전 보장 이사회, 영국(금융 제재 대상 통합 목록 포함), 유럽 연합 및 유럽 연합 회원국(금융 제재 대상 인사, 집단 및 법인 통합 목록 포함)에서 유지 관리하는 제재 또는 수출 제한의 대상 또는 귀하에 대한 관할권을 가진 당국에서 유지 관리하는 기타 제한 인물 목록에 등재되어 있는 자(그와 같이 등재된 자를 <b>“제한된 인물”</b>이라 함)</span></p>
                        
                        <p style="margin-bottom:10.0pt;"><span>b.</span><span>&nbsp;&nbsp;&nbsp;</span><span>포괄적인 제재의 대상이 되는 국가 또는 지역(<b>“금수 지역”</b>)에서 운영 또는 그러한 지역에 위치하거나 거주하는 자.</span></p>
                        
                        <p><span class="index">(f)</span><span>&nbsp;</span><u><span>일반 거래 규정 준수.</span></u>&nbsp;<span>귀하의 '서비스' 사용과 관련하여 귀하는 국제 연합, 중화인민공화국, 미국, 유럽연합, 영국 및 기타 관련 정부 기관의 모든 관련 수출 통제 및 경제 제재 법률 및 규정(통칭 <b>“무역법”</b>)을 준수합니다. 귀하는 본 '서비스'의 사용과 관련하여 '무역법'을 위반하거나 당사가 '무역법'을 위반할 위험을 부담하게 하는 활동에 관여하지 않는 데 동의합니다. 귀하가 '제한된 인물'이거나 '금수 지역' 거주자이거나 '무역법'을 위반하거나 당사가 '무역법'을 위반할 위험을 부담하게 하는 활동에 달리 관여하고 있다고 판단할 만한 근거가 당사에 있는 경우 당사는 단독 재량으로 '무역법'을 위반하는 행위를 중단하도록 요청하거나 '서비스'를 비활성화 또는 일시 중지하거나 '서비스' 즉시 중단하거나 기타 구제 조치를 취하는 등의 모든 관련 조치를 취할 수 있습니다.</span></p>
                        
                        <p><span class="index">(g)</span><span>&nbsp;</span><u><span>제3자 권리.</span></u>&nbsp;<span>제 12항에 설명된 경우를 제외하고 본 '서비스 약관'의 당사자가 아닌 사람은 조항을 이행할 권리를 보유하지 않습니다.</span></p>
                        
                        <p class="title-big"><b><span>25. 문의처 정보</span></b></p>
                        
                        <p><span>본 '서비스 약관'에 관한 질문이 있거나 본 '서비스 약관'으로 인해 또는 그와 관련하여 발생하는 문제의 해결을 요청하려는 경우 더 빠르게 응답해드릴 수 있도록 우선 각 APLUS 게임 내의 지원 기능을 통해 문의해 주시기 바랍니다. 그 외에도 다음에 문의하실 수 있습니다.</span></p>
                        
                        <p><span>컨트롤러 이름: [SUSUMU TANAKA]</span></p>
                        
                        <p><span>주소: Toranomon Hills Mori Tower 8F 1-23-1 Toranomon, Minato-ku, Tokyo Attn: Customer Service Department</span></p>
                        
                        <p><span>이메일: support@sfduelmobile.zendesk.com</span></p>
                        
                        
                        <p class="title_policy"><b><span>별항 B-1: 앱 스토어 약관</span></b></p>
                        
                        <p style="margin-bottom:8.0pt;text-align:left;"><span>귀하가 '앱 스토어'에서 '게임'을 다운로드하는 경우 본 '서비스 약관'에 상반되는 내용이 있더라도 귀하는 다음을 확인하고 이에 동의합니다.</span></p>
                        
                        <p><span>·&nbsp;&nbsp;&nbsp;'게임'에 대한 책임은 전적으로 '앱 스토어'가 아닌 당사에 있습니다.</span></p>
                        
                        <p><span>·&nbsp;&nbsp;&nbsp;'앱 스토어'에는 '게임' 유지 관리 또는 지원을 제공할 의무가 없습니다.</span></p>
                        
                        <p><span>·&nbsp;&nbsp;&nbsp;'게임'이 보증(있는 경우)을 충족하지 못할 경우 귀하는 '앱 스토어'에 통지할 수 있으며, '앱 스토어'는 귀하에게 '게임'의 구매 금액을 환불하고(해당하는 경우) 관련 법률에서 허용하는 최대 범위까지 '앱 스토어'는 '게임'과 관련하여 방법 여하를 불문하고 다른 보증 의무를 부담하지 않습니다. 보증을 준수하지 못해 발생할 수 있는 기타 소송, 손실, 책임, 손해 배상, 비용 또는 지출에 대한 책임은 전적으로 당사에 있습니다.</span></p>
                        
                        <p><span>·&nbsp;&nbsp;&nbsp;'앱 스토어'는 '게임', 귀하의 게임 소유 및 사용과 관련하여 귀하 또는 제3자가 제기하는 클레임을 해결할 책임이 없으며, 이는 (i) 제조물 책임 클레임, (ii) 게임이 관련 법률 또는 규정 요구사항을 준수하지 못했다는 클레임, (iii) 소비자 보호 또는 유사한 법률에 따라 제기되는 클레임을 포함하되 이에 국한되지 않습니다.</span></p>
                        
                        <p><span>·&nbsp;&nbsp;&nbsp;'게임' 또는 귀하의 '게임' 소유 및 사용으로 인해 제3자의 지적 재산권이 침해되었다는 제3자의 클레임이 발생할 경우 본 '서비스 약관'에서 요구하는 범위까지 그러한 지적 재산권 침해 클레임을 조사, 변호, 합의 및 이행할 책임은 전적으로 당사에 있습니다.</span></p>
                        
                        <p><span>·&nbsp;&nbsp;&nbsp;'앱 스토어'와 그 자회사는 본 '서비스 약관'의 제3자 수혜자이며, 귀하가 본 '서비스 약관'을 수락하면 '앱 스토어'는 귀하를 상대로 제3자 수혜자로서 본 '서비스 약관'을 시행할 권리를 보유하게 됩니다.</span></p>
                        
                        <p><span>·&nbsp;&nbsp;&nbsp;귀하는 (i) 미국 정부의 금수 조치 대상이 되는 국가 또는 미국 정부가 테러 지원 국가로 지정한 국가에 있지 않으며 (ii) 미국 정부가 금지 또는 제한 대상으로 지정한 목록에 등재되어 있지 않음을 진술하고 보증합니다.</span></p>
                        
                        <p><span>·&nbsp;&nbsp;&nbsp;귀하는 '게임' 사용 시 모든 관련 제3자 서비스 약관 또는 유사한 계약도 준수해야 합니다.</span></p>
                        
                        <p class="title_policy"><b><span><br clear="all">별항 C-1: 스트리밍 정책</span></b></p>
                        
                        <p  class="title-small"><i><u><span>도입.</span></u></i></p>
                        
                        <p><span>당사는 귀하가 당사의 게임을 즐기기를 바라며 이미지, 동영상, 사운드 효과, 게임 내 음악 또는 당사 게임의 기타 자산(<b>“콘텐츠”</b>)을 사용하여 귀하의 게임 경험을 다른 사용자와 공유하는 라이브 또는 녹화 게임 플레이 동영상(<b>“동영상”</b>)을 제작하려는 귀하의 관심을 지원합니다. 그러나 대부분의 경우 당사의 동의 없이 당사의 '콘텐츠'를 사용하는 것은 불법이며 당사의 권리를 침해하는 것입니다. 본 정책에서는 귀하의 '동영상'에 당사의 '콘텐츠'를 활용해 대중과 귀하의 경험을 공유할 수 있도록 당사가 귀하에게 부여하는 제한된 권한에 대해 안내합니다.</span></p>
                        
                        <p class="title-small"><i><u><span>'동영상'에 당사의 '콘텐츠'를 사용하는 것은 본 '스트리밍 정책'에 따라 명시적으로 기술된 경우를 제외하고는 비상업적 목적으로 제한되어야 합니다</span></u></i><i><span>:</span></i></p>
                        
                        <p><span>본 '스트리밍 정책'에 명시적으로 기술하는 경우를 제외하고는 당사의 '콘텐츠'를 귀하의 '동영상'에 비상업적 용도로만 사용할 수 있습니다. 따라서 귀하는 당사의 서면 승인을 먼저 받지 않은 상태로 수수료 또는 다른 형태의 보상을 받거나 기타 상업적 용도로 기업 또는 타인에게 당사의 '콘텐츠'를 활용하는 귀하의 '동영상'에 대한 라이선스를 부여할 수 없습니다. 당사는 당사 자체 '동영상'을 상업적 목적으로 사용할 권리를 보유합니다. 또한 당사 '콘텐츠'를 사용하는 귀하의 '동영상'에는 당사의 단독 재량에 따라 교육용 또는 홍보용으로 만들 수 있는 코멘터리, 게임플레이 또는 충분한 오리지널리티가 포함되어야 합니다. 본 정책에 따라 자격이 부여되지 않는 '동영상'의 예로는 게임의 컷신 클립 또는 특정 게임 사운드트랙의 레코딩(컷신 또는 사운드트랙에 대한 코멘터리 없이)을 들 수 있습니다.</span></p>
                        
                        <p><span>그러나 당사는 귀하가 본 '스트리밍 정책'의 다른 부분을 준수하는 경우 다음과 같은 두 가지 방법에 따라 결제를 받을 수 있도록 허용합니다.</span></p>
                        
                        <p><span>·&nbsp;&nbsp;&nbsp;</span><span>YouTube 또는 Twitch와 같이 귀하의 '동영상'을 호스팅하는 플랫폼(이하 <b>“플랫폼”</b>)에 의해 게재되는 광고를 통해 당사의 '콘텐츠'를 활용하는 귀하의 '동영상'에서 수익을 창출하는 방법.</span></p>
                        
                        <p><span>·&nbsp;&nbsp;&nbsp;</span><span>'플랫폼'에서 귀하의 프로필 또는 '동영상' 설명에 게시된 기부 링크를 통해 기부를 받는 방법.</span></p>
                        
                        <p class="title-small"><i><u><span>귀하가 동영상을 배포할 수 있는 방법:</span></u></i></p>
                        
                        <p><span>관련 '서비스 약관' 및 본 '스트리밍 정책'의 조항에 따라 귀하는 당사 '콘텐츠'를 사용하여 '동영상'을 만들 수 있으며, 귀하는 시청자가 어떠한 종류의 요금도 지불하지 않고 그러한 '동영상'을 볼 수 있는 웹사이트에 그러한 '동영상'을 자유롭게 배포할 수 있습니다. 당사는 일부 웹사이트에서 유료 서비스를 제공할 수 있음을 인지하고 있습니다. 그러한 '동영상'을 호스팅하는 웹사이트에서 시청자가 동영상을 무료로 볼 수 있는 방법을 제공하는 경우 귀하는 해당 웹사이트에 '동영상'을 배포할 수 있습니다.</span></p>
                        
                        <p class="title-small"><i><u><span>당사 '콘텐츠'를 활용해 귀하의 '동영상'에 포함해서는 안 되는 내용:</span></u></i></p>
                        
                        <p><span>'서비스 약관'에서 '사용자 콘텐츠'로 금지되는 콘텐츠 및 다음 내용은 '동영상'에 포함할 수 없습니다('동영상'과 같은 페이지에 또는 가까이에 링크된 위치에도 안 됨).</span></p>
                        
                        <p><span>·&nbsp;&nbsp;&nbsp;당사에서 '동영상'을 제작했다고 암시하거나 당사가 귀하 또는 귀하의 '동영상'을 지지한다고 암시할 수 있는 모든 내용(별도의 서면 또는 기타 합의에 따라 당사와 지지 관계를 맺고 있는 경우 제외)</span></p>
                        
                        <p><span>·&nbsp;&nbsp;&nbsp;치트, 핵, 취약점, 버그 또는 제3자 프로그램과 관련된 모든 정보(이와 관련된 링크 포함)</span></p>
                        
                        <p><span>·&nbsp;&nbsp;&nbsp;관련 법률을 위반하거나 당사에 비판적이거나 당사의 재량에 따라 판단했을 때 당사의 가치, 영업권 또는 평판, 당사 제휴사, 당사 제품, '콘텐츠' 또는 브랜드를 손상시킬 수 있는 당사 '콘텐츠' 사용 방식</span></p>
                        
                        <p><span>·&nbsp;&nbsp;&nbsp;공중 도덕 및 윤리에 위배되는 행동 또는 행위.</span></p>
                        
                        <p class="title-small"><i><u><span>등급: 귀하의 '동영상'을 다음에 따라 적절하게 유지하십시오.</span></u></i></p>
                        
                        <p><span>귀하의 '동영상'은 관련 게임의 등급 가이드라인과 부합해야 하며 어떠한 경우에도 엔터테인먼트 소프트웨어 등급 위원회(<b>“ESRB”</b>)의 “T” 등급 또는 전 유럽 게임 정보(<b>“PEGI”</b>)의 “16” 등급을 위반하는 콘텐츠를 포함해서는 안 됩니다.</span></p>
                        
                        <p class="title-small"><i><u><span>공개: 귀하는 당사를 당사 '콘텐츠'의 저작권 소유자로 명시하고 당사의 지지를 부인해야 합니다.</span></u></i></p>
                        
                        <p><span>귀하가 제공하는 당사 '콘텐츠'를 활용한 모든 '동영상'에는 다음과 같이 명시적인 부인 정보가 포함되어야 합니다('동영상' 시작 부분 또는 라이브 스트리밍인 경우 눈에 띄는 글꼴로 '동영상' 근처에).</span></p>
                        
                        <p><span>·&nbsp;&nbsp;&nbsp;상표, 저작권 및 기타 지적 재산권을 포함하여 여기에 제공되는 콘텐츠의 일부는 A PLUS JAPAN Inc. 또는 그 라이선스 부여자(“APLUS”)가 소유 또는 보유하며, 동일한 대상의 모든 권리는 APLUS에서 보유합니다. 본 콘텐츠는 공식 APLUS 콘텐츠가 아니며 APLUS에서 지지 또는 승인한 것이 아닙니다. </span></p>
                        
                        <p class="title-small"><i><u><span>추가 중요 정보:</span></u></i></p>
                        
                        <p style="margin-bottom:8.0pt;text-align:left;"><span>당사에서 단독으로 결정하는 바에 따라 당사는 비즈니스상 이유 또는 기타 이유로 귀하에 대한 통지 또는 책임 없이 당사 '콘텐츠'를 활용한 '동영상'을 호스팅, 배포 또는 달리 제공할 귀하의 권리를 종료할 수 있습니다.  이러한 경우 당사는 귀하 또는 관련 웹사이트 또는 '플랫폼'에 그러한 '동영상'에 대한 그러한 권리의 종료와 관련해 연락할 수 있으나 반드시 그래야 하는 것은 아닙니다.</span></p>
                        
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        </div>



                </div>
            </div>
        </div>
    </div>

        </body>
        </html>


    `
}

function getEnStr() {
    return `
    <!DOCTYPE html>
    <html>
        <head>
            <meta charset="utf-8">
            <title>Privacy Policy</title>
              <meta name="format-detection" content="telephone=no" />
              <meta name="viewport" content="width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no" />
              <style type="text/css">

              .news_body{
                color: #f4f4f4;
            }
            table{
                margin-top: 10px;
                border-collapse: collapse;
                width: 100%;
            }
            td{
                padding: 5px 10px;
            }
            table, td, th{
                border: 1px solid #A6A6A6;
            }
    
            .column-policy {
                width: 90%;
                margin: auto;
                font-family: Arial, Helvetica, sans-serif;
                font-size: 15px;
                line-height: 20px;
                color: #666666;
            }
    
            .title_policy {
                text-align: center;
                font-size: 30px;
                padding-top: 10px;
                display: inline-block;
                width: 100%;
            }
    
            .title-small {
                width: 100%;
                margin-top: 20px;
                font-size: 16px;
                color: #777;
                line-height: 1.2;
                padding-bottom: 5px;
            }
    
            .dot_small_title {
                margin-left: 20px;
                padding: 5px 20px 5px 10px;
                list-style-type: disc;
            }
    
            .title-big {
                width: 100%;
                margin-top: 30px;
                font-size: 20px;
                color: #999;
                line-height: 1.2;
                padding: 0 0 10px 0;
            }
            @media (max-width: 1024px) {
                td{
                    padding: 5px 2px;
                }
                .column-policy {
                    font-size: 14px;
                    width: 96%;
                }
                table{
                    position: relative;
                    left: -1%;
                }
                .wrp{
                    padding-bottom: 0;
                }
            }

       
              </style>
        </head>
        <body>

        <div class="wrp">
		<div class="wrp2">
			<div class="mask"></div>
            <div class="news_show">
                <div class="news_body column-policy" id="privacyDetail">

                    <div class="WordSection1" >

                        <p  align="center" style="margin-bottom:
                        8.0pt;text-align:center;"><span class="title_policy">TERMS
                        OF SERVICE</span><span  style="
                        "><o:p></o:p></span></p>
                        
                        <p  align="center" style="margin-bottom:
                        8.0pt;text-align:center;"><span  >Effective
                        Date: December 18, 2022</span><span  style="
                        
                        "><o:p></o:p></span></p>
                        
                        <p  class="title-big"><span ><b><span  style="
                        ">1.</span></b></span><span ><b><span  style="
                        
                        ">&nbsp;&nbsp;</span></b></span><span ><b><span  style="
                        
                        ">A few important notices—arbitration, refunds, class
                        actions and damages</span></b></span></p>
                        <p  style="
                        "><b><span  style="
                        ">IMPORTANT NOTICE
                        REGARDING ARBITRATION FOR US RESIDENTS: WHEN YOU AGREE TO THIS TERMS OF SERVICE
                        YOU ARE AGREEING (WITH LIMITED EXCEPTION) TO RESOLVE ANY DISPUTE BETWEEN YOU
                        AND US THROUGH BINDING, INDIVIDUAL ARBITRATION RATHER THAN IN COURT. PLEASE
                        REVIEW CAREFULLY SECTIONS&nbsp;22&nbsp;“DISPUTE RESOLUTION” BELOW FOR DETAILS
                        REGARDING ARBITRATION.&nbsp;</span></b><b><span  style="
                        
                        ">THIS TERMS OF SERVICE ALSO INCLUDES A WAIVER
                        OF RIGHTS BY YOU TO BRING A CLASS ACTION AGAINST US AND A LIMITATION ON DAMAGES
                        THAT YOU CAN COLLECT FROM US THAT MAY ARISE OUT OF YOUR USE OF THE SERVICES. BY
                        USING THE SERVICES, YOU AGREE TO THESE PROVISIONS.</span></b><span  style="
                        "><o:p></o:p></span></p>
                        
                        <p  style="
                        "><b><span  style="
                        ">IF YOU DO NOT AGREE TO THE TERMS OF THIS
                        TERMS OF SERVICE, YOU MAY NOT INSTALL, COPY, OR USE OUR SERVICES. WE DO NOT
                        NORMALLY OFFER REFUNDS, EXCEPT WHERE EXPRESSLY AUTHORIZED BY US (SEE SECTION 10
                        FOR EXCEPTIONS), OR WHERE REFUNDS ARE REQUIRED UNDER LOCAL LAW.</span></b><span  style="
                        "><o:p></o:p></span></p>
                        
                        <p  style="
                        "><b><span  style="
                        ">OUR TERMS OF SERVICE MAY ALSO CONTAIN
                        COUNTRY-SPECIFIC ADDENDA THAT APPLY TO YOU BASED ON THE JURISDICTION IN WHICH
                        YOU RESIDE.</span></b><span>&nbsp;<b>To see additional terms applicable to you (which constitute part
                        of this agreement and may supersede these terms), please check the country-specific
                        language on the TERMS OF SERVICE website</b></span><b><span  style="
                        ">.</span></b><span  style="
                        "><o:p></o:p></span></p>
                        
                        <p  class="title-big"><a name="_Toc1052380"></a><a name="_Toc77497092"></a><a name="_Toc1401366"></a><a name="_Toc19737859"></a><span style="mso-bookmark:_Toc1052380"><b><span  style="
                        
                        ">2.</span></b></span><span style="mso-bookmark:_Toc1052380"><b><span  style="
                        ">&nbsp;&nbsp;</span></b></span><span style="mso-bookmark:_Toc1052380"><b><span  style="
                        
                        ">What is this document? When can I play?</span></b></span><b><span  style="
                        "><o:p></o:p></span></b></p>
                        
                        <p  style="
                        "><span  style="
                        ">You are now reading our TERMS OF SERVICE
                        which is a legal agreement between you and&nbsp;</span><span  >A PLUS
                        JAPAN Inc.</span><span  style="
                        ">&nbsp;(“<b>we</b>”,
                        “<b>us</b>”, “<b>our</b>”, as appropriate) regarding the Services you use from
                        us. “<b>Services</b>” mean collectively, and sometimes individually, the
                        following: (a) each of our Games, and (b) any websites, software or other
                        services we provide with or in support of the Game, whether or not they are
                        installed or used on a computer, console, or a mobile device. “<b>Game</b>”
                        means our game that you download and access that is subject to this TERMS OF
                        SERVICE, regardless of where you download and/or access it, and any
                        documentation, software, updates, Virtual Goods and Content (each defined
                        below) included in it.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span>We’ve tried to be
                        straightforward in this TERMS OF SERVICE, and if</span><span  style="
                        ">&nbsp;you have any questions feel free
                        to send us a note at&nbsp;</span><span  >support@sfduelmobile.zendesk.com</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">(our “<b>Support Email
                        Address</b>”)<span style="color:black">.&nbsp; <o:p></o:p></span></span></p>
                        
                        <p  class="title-big"><a name="_Toc77497102"></a><a name="_Toc19737860"></a><a name="_Toc1401367"></a><a name="_Toc1052381"></a><a name="_Toc77497093"></a><a name="_Toc77497094"></a><a name="_Toc77497095"></a><a name="_Toc77497096"></a><a name="_Toc77497097"></a><a name="_Toc77497098"></a><a name="_Toc77497099"></a><a name="_Toc77497100"></a><a name="_Toc77497101"></a><b><span  style="
                        ">3.</span></b><b><span  style="
                        ">&nbsp;&nbsp;</span></b><b><span  style="
                        ">Defined Terms<o:p></o:p></span></b></p>
                        
                        <p  style="
                        "><span  style="
                        ">You’ll notice some capitalized terms in
                        this TERMS OF SERVICE. They’re called “defined terms,” and we use them so we
                        don’t have to repeat the same language again and again, and to make sure that
                        the use of these terms is consistent throughout the TERMS OF SERVICE.&nbsp;
                        We’ve included the defined terms throughout because we want it to be easy for
                        you to read them in context.<o:p></o:p></span></p>
                        
                        <p  class="title-big"><a name="_Toc1052382"></a><a name="_Toc77497103"></a><a name="_Toc1401368"></a><a name="_Toc19737861"></a><span ><b><span  style="
                        
                        ">4.</span></b></span><span ><b><span  style="
                        ">&nbsp;&nbsp;</span></b></span><span ><b><span  style="
                        
                        ">Additional Terms</span></b></span><b><span  style="
                        "><o:p></o:p></span></b></p>
                        
                        <p  style="
                        "><span  style="
                        
                        ">Some Services may be available (or only available)
                        through accessing (or downloading from) a third-party platform or store,
                        including but not limited to, Facebook, the Epic Games Store, Steam game
                        platform, the Google Play Store and Apple App Store (each, an “<b>App Store</b>”).
                        Your use of the Services is also governed by any applicable agreements you have
                        with any App Store (the “<b>App Store Agreement(s)</b>”).&nbsp;In the event of
                        a conflict between any other App Store Agreement(s) from which you acquire one
                        of our Games and this TERMS OF SERVICE with respect to your use of the
                        Services, this TERMS OF SERVICE will take priority.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        
                        ">The collection of information from you and related to the
                        Services (whether obtained through an App Store or not) is governed by our
                        Privacy Policy at December 18, 2022. Our Privacy Policy explains how we
                        collect, use, and disclose information that we collect from and about you.<o:p></o:p></span></p>
                        
                        <p  class="title-big"><a name="_Toc1052383"></a><a name="_Toc77497104"></a><a name="_Ref67769377"></a><a name="_Toc1401369"></a><a name="_Toc19737862"></a><span style="mso-bookmark:_Toc1052383"><b><span  style="
                        ">5.</span></b></span><span style="mso-bookmark:_Toc1052383"><b><span  style="
                        
                        ">&nbsp;&nbsp;</span></b></span><span style="mso-bookmark:_Toc1052383"><b><span  style="
                        
                        ">Eligibility and Registration</span></b></span><b><span  style="
                        "><o:p></o:p></span></b></p>
                        
                        <p  style="
                        "><a name="_Hlk72504646"><span class="index" style="
                        ">(a)</span></a><span style="mso-bookmark:_Hlk72504646"><span  style="
                        
                        ">&nbsp;</span></span><span style="mso-bookmark:_Hlk72504646"><u><span  style="
                        
                        ">Age</span></u></span><span style="mso-bookmark:_Hlk72504646"></span><span  style="
                        ">.&nbsp;To create
                        a Game Account (as defined below) and access some of our Services, you must be
                        at least the minimum age for consenting to personal data collection under the
                        law in your jurisdiction. If you are between the minimum age for personal data
                        collection and age of majority in your jurisdiction, your parent or guardian
                        must review this TERMS OF SERVICE and accept it on your behalf. Parents and
                        guardians are responsible for the acts of their children under 18 years of age
                        when using our Services.&nbsp;<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">We may allow a
                        minor under the minimum age for personal data collection to register for
                        certain Services with the verified consent of a parent or legal guardian. The
                        parent/legal guardian may be asked to provide additional documentation or
                        perform additional actions as part of the verification and approval process as
                        consistent with applicable law. We recommend that parents and guardians
                        familiarize themselves with parental controls on the devices they provide their
                        child.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(b)</span><span  style="
                        ">&nbsp;</span><u><span  style="
                        ">Account Creation</span></u><span  style="
                        ">. To access
                        parts of a Game, you may need to create an in-game account (your “<b>Game
                        Account</b>”). Your Game Account, if applicable, is separate from any account
                        you may have with any App Store (your “<b>App Store Account</b>”). You may be
                        able to create your Game Account using an existing account you have with us or
                        your email address. To the extent you create your Game Account through the use
                        of a third-party account (for example, your account with Facebook or Google),
                        we may access certain personal information that this third party provides to us
                        such as your email address and name to help create your Game Account. Further
                        information about use of third-party accounts is provided in the&nbsp;Privacy
                        Policy at </span><span  style="
                       ">December 18, 2022</span><span  style="
                        ">.&nbsp;Please note that you may also be
                        able to play the Game without creating a Game Account, but you may not be able
                        to access certain parts of the Game, and your Game data may be deleted if you
                        uninstall or otherwise delete the Game.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(c)</span><span  style="
                        "></span><u><span  style="
                        ">Keep Your
                        Information Current</span></u><span  style="
                        
                        ">. It’s important that you provide us with accurate,
                        complete and up-to-date information for your Game Account and you agree to update
                        such information to keep it that way. If you don’t, we may suspend or terminate
                        your Game Account. You agree that you will not disclose your Game Account
                        password to anyone and will notify us immediately of any unauthorized use of
                        your Game Account. You are responsible for all activities that occur under your
                        Game Account, whether or not you know about them.&nbsp;&nbsp;If you believe
                        that your Game Account is no longer secure, then you must immediately notify us
                        at our Support Email Address.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(d)</span><span  style="
                        ">&nbsp;</span><u><span  style="
                        ">No Account
                        Sharing.</span></u><span  style="
                        ">&nbsp;&nbsp;You
                        may not sell, resell, rent, lease, share or provide access to your Game Account
                        to anyone else. We reserve all available legal rights and remedies to prevent
                        unauthorized use of our Services, including, but not limited to, technological
                        barriers, IP mapping, and, in serious cases, directly contacting your Internet
                        Service Provider (ISP) regarding such unauthorized use.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(e)</span><span  style="
                        ">&nbsp;</span><u><span  style="
                        ">No False
                        Accounts.</span></u><span  style="
                        ">&nbsp;You may
                        not create a Game Account for anyone else or create a Game Account in a name
                        other than your own.<o:p></o:p></span></p>
                        
                        <p  class="title-big"><a name="_Ref526361970"></a><a name="_Toc77497105"></a><a name="_Ref67769277"></a><a name="_Toc1401370"></a><a name="_Toc19737863"></a><a name="_Toc1052384"></a><span style="mso-bookmark:
                        _Ref526361970"><b><span  style="
                        ">6.</span></b></span><span style="mso-bookmark:_Ref526361970"><b><span  style="
                        
                        ">&nbsp;&nbsp;</span></b></span><span style="mso-bookmark:_Ref526361970"><b><span  style="
                        
                        ">License</span></b></span><b><span  style="
                        ">&nbsp;and Use of the Services<o:p></o:p></span></b></p>
                        
                        <p  style="
                        "><a name="_Ref67769529"><span  class="index" style="
                        ">(a)</span></a><span style="mso-bookmark:_Ref67769529"><span  style="
                        
                        ">&nbsp;</span></span><span style="mso-bookmark:_Ref67769529"><u><span  style="
                        
                        ">License Grant</span></u></span><span style="mso-bookmark:
                        _Ref67769529"><span  style="
                        ">. So long as you
                        comply with this TERMS OF SERVICE and, as applicable, the App Store
                        Agreement(s), we grant you the following license: a personal, non-exclusive,
                        non-transferable, non-sublicensable limited right and license to (i) download
                        and install the Game on the device permitted by the App Store Agreement(s) (if
                        applicable), and (ii) access and use the Services, including any Content,
                        for&nbsp;your personal entertainment purposes leveraging only the functionality
                        of the Game and Services. We and our licensors reserve all rights not granted
                        to you in this TERMS OF SERVICE.&nbsp;</span></span><span  style="
                        ">“<b>Content</b>” means all artwork,
                        titles, themes, objects, characters, names, dialogue, catch phrases, stories,
                        animation, concepts, sounds, audio-visual effects, methods of operation,
                        musical compositions, Virtual Goods (defined in Section&nbsp;9) and any other
                        content within the Services. Content also includes anything generated, created,
                        or that is otherwise developed within the Services by any user (including you)
                        as a result of interaction with the functionality of the Services. We also
                        grant you a limited license to make gameplay videos for certain Games,
                        specified on the Services provided that you agree that all such gameplay video
                        activity is subject to your agreement to and pursuant to our Streaming Policy
                        in Schedule C-1.&nbsp; We may, in our sole discretion, remove, edit or disable
                        any Content for any reason.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><a name="_Ref67769534"><span class="index" style="
                        ">(b)</span></a><span style="mso-bookmark:_Ref67769534"><span  style="
                        
                        ">&nbsp;</span></span><span style="mso-bookmark:_Ref67769534"><u><span  style="
                        
                        ">Content You Create Outside the Services</span></u></span><span style="mso-bookmark:_Ref67769534"><span  style="
                        
                        ">.</span></span><span style="mso-bookmark:_Ref67769534"></span><span  >&nbsp;</span><span  style="
                        ">“<b>User Content</b>”
                        means any Content that you (or other Game Account holders) create or obtain
                        outside the Services that you or another user makes available within the
                        Services. To be clear, if Content is created within the Services, it is&nbsp;<u>not</u>&nbsp;User
                        Content; only Content created or obtained from&nbsp;<u>outside</u>&nbsp;the
                        Services that a user then makes available within the Services is User Content.
                        By making any User Content available through the Services you hereby grant to
                        us the following license: a non-exclusive, transferable, worldwide,
                        royalty-free license, with the right to sublicense, to use, copy, modify,
                        create derivative works based upon, distribute, publicly display, and publicly
                        perform your User Content in connection with operating and providing the
                        Services and Content to you and to other users of the Services. Except to the
                        extent prohibited by law, you waive the benefit of any “moral rights” or “droit
                        moral” or similar rights in any country to any User Content.&nbsp; We may, in
                        our sole discretion, remove, edit or disable any User Content at any time and
                        for any reason, including if we determine that the User Content violates this TERMS
                        OF SERVICE. We do not assume any responsibility or liability for User Content,
                        for removing it, or not removing it or other Content. We do not pre-screen or
                        review any User Content and do not approve or endorse any User Content that may
                        be available on the Services or our other services.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(c)</span><span  style="
                        "></span><u><span  style="
                        ">Service Limits
                        Based on Where You Live</span></u><span  style="
                        
                        ">.<i>&nbsp;</i>We may restrict, modify, or limit your
                        access to and use of certain Content, Virtual Goods, an entire Game, or any or
                        all of the Services depending on the territory in which you are located. Without
                        limiting the foregoing,&nbsp;Content, Virtual Goods, entire&nbsp;Games, or the
                        Services&nbsp;may not be available (in&nbsp;whole or in part) where&nbsp;you
                        are located&nbsp;or may only be available in a modified version, if they do not
                        comply with the laws which apply in your country.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><a name="_Ref67769387"><span class="index" style="
                        ">(d)</span></a><span style="mso-bookmark:_Ref67769387"><span  style="
                        
                        ">&nbsp;</span></span><span style="mso-bookmark:_Ref67769387"><u><span  style="
                        
                        ">Retail Purchase</span></u></span><span style="mso-bookmark:
                        _Ref67769387"></span><i><span >.&nbsp;</span></i><span>We may offer codes or product keys that can be activated in a Game or used
                        to activate a Game on the App Store.&nbsp;Subject to foreign exchange control
                        regulations applicable in your jurisdiction,&nbsp;such codes or keys must be
                        purchased (or otherwise obtained legally) through us or one of our authorized
                        retailers to be valid. If you purchase such a code or key from a third party,
                        that third party is responsible for addressing any issues you have with these
                        codes or keys. Subject to applicable law, we will have no responsibility for
                        these codes or keys purchased from any third party&nbsp;or if any purchase
                        occurred in breach with any applicable foreign exchange control regulations.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(e)</span><span  style="
                        ">&nbsp;</span><u><span  style="
                        ">Minimum
                        Requirements</span></u><span  >. The Game may have minimum requirements for the devices and systems on
                        which you wish to play the Game. We may publish these minimum requirements on
                        the applicable website and/or otherwise notify you in writing. For an optimal
                        experience, please ensure that your devices and systems will meet these
                        requirements before playing the Game.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(f)</span><span  style="
                        ">&nbsp;</span><u><span  style="
                        ">Seizure Warning</span></u><span  style="
                        ">. The Game may
                        contain flashing lights, images, and other luminous stimulations which may
                        induce epileptic seizures in certain individuals. If you or anyone in your
                        household has an epileptic condition, please consult your doctor before playing
                        any Game. If you experience dizziness, altered vision, eye or muscle twitches,
                        loss of awareness, disorientation, any involuntary movement, or convulsions while
                        playing, please immediately discontinue playing the Game and consult your
                        doctor.<o:p></o:p></span></p>
                        
                        <p  class="title-big"><a name="_Ref67769076"></a><a name="_Toc77497106"></a><a name="_Ref67769169"></a><span style="mso-bookmark:
                        _Ref67769076"><b><span  style="
                        ">7.</span></b></span><span style="mso-bookmark:_Ref67769076"><b><span  style="
                        
                        ">&nbsp;&nbsp;</span></b></span><span style="mso-bookmark:_Ref67769076"><b><span  style="
                        
                        ">Player Conduct</span></b></span><b><span  style="
                        "><o:p></o:p></span></b></p>
                        
                        <p  style="
                        "><span  style="
                        ">You agree not to do any of the following
                        with respect to the Services, as determined by us, as applicable:<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  class="index" style="
                        ">(a)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">use them
                        commercially, for a promotional purpose, or for the benefit of any third party
                        or in any manner not permitted by this TERMS OF SERVICE;<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(b)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">use, or provide,
                        any unauthorized third-party programs that intercept, emulate, or redirect any
                        communication between the Services and us or that collect information about the
                        Game;<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(c)</span><span  style="
                        "></span><span  style="
                        ">use, or provide
                        ancillary offerings to anyone, that are not offered within the Services by us
                        (or the functionality of the App Store), such as hosting, “leveling” services,
                        mirroring our servers, matchmaking, emulation, communication redirects, mods,
                        hacks, cheats, bots (or any other automated control), trainers and automation
                        programs that interact with the Services in any way, tunneling, third party
                        program add-ons, and any interference with online or network play;<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(d)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">access or use
                        them on more than one device at a time;<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(e)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">copy, reproduce,
                        distribute, display, mirror, frame or use them (or any of our other materials,
                        intellectual property, or proprietary information) in a way that is not
                        expressly authorized in this TERMS OF SERVICE;<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(f)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">sell, rent,
                        lease, license, distribute, or otherwise transfer the Services, Game or any
                        Content, including, without limitation, Virtual Goods or Game Currency,
                        including participating in or operating so called “secondary markets” for
                        Virtual Goods, Game Currency or Content;<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(g)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">attempt to
                        reverse engineer (except as otherwise permitted by applicable local law),
                        derive source code from, modify, adapt, translate, datamine, decompile, or
                        disassemble or make derivative works based upon the Services or any Content;<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(h)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">remove, disable,
                        circumvent, or modify any technological measure we implement to protect them or
                        any of their associated intellectual property;<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(i)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">create, develop,
                        distribute, or use any unauthorized software programs to gain advantage in any
                        online or other game modes or otherwise Cheat (as defined below);<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(j)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">attempt to
                        probe, scan or test its vulnerability or breach any security or authentication
                        measures;<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(k)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">access, tamper
                        with, or use non-public areas of the Services;<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(l)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">trespass, or
                        attempt to gain access to a property or location where you do not have
                        permission to be or engage in any activity that may result in injury, death,
                        property damage, nuisance or other liability;<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(m)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">upload, publish,
                        submit or transmit any User Content, create a user name or account name, or
                        otherwise engage in any behavior that: (i) infringes, misappropriates or
                        violates a third party’s patent, copyright, trademark, trade secret,
                        contractual rights, moral rights or other intellectual property rights, or
                        rights of publicity or privacy, or any other rights of third parties; (ii)
                        violates, or encourages any conduct that would violate any applicable law or
                        regulation or would give rise to civil liability; (iii) is fraudulent, false,
                        misleading or deceptive; (iv) is grossly harmful, racially or ethnically
                        objectionable, disparaging, blasphemous, libelous, defamatory, obscene,
                        pornographic,&nbsp;</span><span >paedophilic</span><span  style="
                        ">, vulgar or offensive; (v) promotes
                        discrimination, bigotry, racism, hatred, harassment or harm against any
                        individual or group; (vi) is violent, bullying, or threatening or promotes
                        violence, money laundering or gambling, terrorism, or actions that are
                        threatening or disrespectful to any person or entity; (vii) harms minors in any
                        way; or (viii) promotes illegal or harmful activities or substances;<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(n)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">engage in any
                        behavior that: (i) violates, or encourages any conduct that would violate any
                        applicable law or regulation or would give rise to civil liability; (ii) is
                        fraudulent, false, misleading or deceptive, including “trolling;” (iii) is
                        defamatory, obscene, pornographic, vulgar or offensive; (iv) promotes
                        discrimination, bigotry, racism, hatred, harassment or harm against any
                        individual or group; (v) is disruptive to the Game, App, its users or user
                        community,&nbsp; is violent, bullying, or threatening or promotes violence,
                        terrorism, or actions that are threatening or disrespectful to any person or
                        entity; or (vi) promotes illegal or harmful activities or substances;<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(o)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">interfere with,
                        or attempt to interfere with, the access of any user, host or network,
                        including, without limitation, sending a virus, overloading, flooding,
                        spamming, or mail-bombing the Services or any of its users;<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(p)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">collect or store
                        any information that could be used to identify an individual, either itself or
                        combined with other information, from the Services from other users of the
                        Services without their express permission;<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(q)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">behave in a
                        manner which is detrimental to the enjoyment of the Services by other users as
                        intended by us, in our sole judgment, including, without limitation,
                        harassment, use of abusive or offensive language, game abandonment, game
                        sabotage, spamming, behaving in a disruptive manner, social engineering, or
                        scamming, or contrary to public morals or public policy;<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(r)</span><span  style="
                        "></span><span  style="
                        ">impersonate or
                        misrepresent your affiliation with any person or entity, or deceives or
                        misleads the addressee about the origin of such messages or communicates any
                        information which is grossly offensive or menacing in nature;<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(s)</span><span  style="
                        "></span><span  style="
                        ">use IP proxying
                        or other methods to disguise the place of your residence, whether to circumvent
                        geographical restrictions on the Services or for any other purpose;<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(t)</span><span  style="
                        "></span><span  style="
                        ">play on another
                        person’s Game Account to “boost” that Game Account’s status, level or rank;<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(u)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">use the Services
                        in any way that would affect us adversely or reflect negatively on us or the Services
                        or discourage any person from using all or any portion of the features of the
                        Services;<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(v)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">encourage,
                        promote, take part in or enable anyone else to do any of the foregoing; or<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(w)</span><span  style="
                        ">&nbsp;&nbsp;</span><span  style="
                        ">violate any
                        applicable law or regulation.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">If you encounter another user who is
                        violating any of these rules, please report this activity to us using the
                        “Report Abuse” function in the relevant Game or part of the Service, if
                        available, or contact us at </span><span  >support@sfduelmobile.zendesk.com</span><span  style="
                        ">.<o:p></o:p></span></p>
                        
                        <p  class="title-big"><a name="_Toc1052386"></a><a name="_Ref527537021"></a><a name="_Ref526352598"></a><a name="_Toc77497107"></a><a name="_Toc1401372"></a><a name="_Toc19737865"></a><a name="_Ref1051796"></a><span style="mso-bookmark:_Toc1052386"><b><span  style="
                        
                        ">8.</span></b></span><span style="mso-bookmark:_Toc1052386"><b><span  style="
                        ">&nbsp;&nbsp;</span></b></span><span style="mso-bookmark:_Toc1052386"><b><span  style="
                        
                        ">Ownership</span></b></span><b><span  style="
                        ">&nbsp;of the Services<o:p></o:p></span></b></p>
                        
                        <p  style="
                        "><span  style="
                        ">We and our affiliates and licensors own
                        all title, ownership and intellectual property rights in the Services. You
                        agree not to remove, alter or obscure any copyright, trademark, service mark or
                        other proprietary rights notices incorporated in or accompanying the
                        Services.&nbsp; You understand and agree that you have no ownership interest in
                        the Services or any Games or Content therein.&nbsp;The Services (and
                        particularly our Games) may have built-in mechanisms designed to prevent
                        granting one user an unfair advantage over other users (these actions are “<b>Cheating</b>”
                        and the software is the “<b>Cheat Detection Software</b>”). We may add or
                        update our Cheat Detection Software periodically as we may require in our sole
                        discretion. The Services and/or the Cheat Detection Software may collect and
                        transmit details about your Game Account, gameplay, and unauthorized programs
                        or processes in connection with Cheating, subject to our Privacy Policy and
                        applicable law. In the event that we in our sole discretion conclude that you
                        are Cheating, you agree that we may exercise any or all of our rights under
                        this TERMS OF SERVICE, including termination of this TERMS OF SERVICE and your
                        access to our Services. In addition, if you Cheat in one Game or Service, we
                        may terminate your license to use all of our Games and Services.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">Although we are not obligated to monitor
                        access to or use of the Services or to review or edit any Content, we have the
                        right to do so for the purpose of operating and publishing the Services, to
                        ensure compliance with this TERMS OF SERVICE, to protect the health or safety
                        of anyone that we believe may be threatened, to protect our legal rights and
                        remedies, to report a crime or offensive behavior, or to comply with applicable
                        law. We may (but don’t have to) remove or disable access to any Content, at any
                        time and without notice. We may (but don’t have to) investigate violations of
                        this TERMS OF SERVICE or conduct that affects the Services.<o:p></o:p></span></p>
                        
                        <p  class="title-big"><a name="_Ref1401265"></a><a name="_Toc77497108"></a><a name="_Toc1401373"></a><a name="_Toc19737866"></a><a name="_Toc1052387"></a><span style="mso-bookmark:_Ref1401265"><b><span  style="
                        ">9.</span></b></span><span style="mso-bookmark:_Ref1401265"><b><span  style="
                        
                        ">&nbsp;&nbsp;</span></b></span><span style="mso-bookmark:_Ref1401265"><b><span  style="
                        
                        ">Virtual Goods and Game</span></b></span><b><span  style="
                        ">&nbsp;Currency<o:p></o:p></span></b></p>
                        
                        <p  style="
                        "><span  class="index" style="
                        ">(a)</span><span  style="
                        ">&nbsp;</span><u><span  style="
                        ">Purchasing or
                        Obtaining Virtual Goods and Game Currency</span></u><span  style="
                        ">. Subject to applicable foreign exchange
                        control regulations in your jurisdiction, we may offer certain upgrades and
                        options within our Games that you can buy with real world currency, including,
                        but not limited to, in-game currency where permitted under applicable law (“<b>Game
                        Currency</b>”), character skins, mounts and vehicles, digital cards, experience
                        boosts, gear and other customizations for your in-Game characters, and other
                        such digital add-on items that may improve your Game experience in some way (“<b>Virtual
                        Goods</b>”). Except as otherwise communicated to you within the functionality
                        of the Game, Game Currency and Virtual Goods are not transferable from one Game
                        to another. You may also be able to obtain certain Virtual Goods and Game
                        Currency without making a purchase, such as an in-Game award. When you purchase
                        Game Currency, Virtual Goods, or a Game itself (each, a “<b>Transaction</b>”),
                        your purchase will be made through the functionality available through the App
                        Store or other platforms we make available to you. Prior to making a
                        Transaction, you should make sure you fully understand the agreement that
                        covers your Transaction, whether that agreement is an App Store Agreement or
                        another payment platform agreement<span style="mso-spacerun:yes">&nbsp;
                        </span>There may be limits to the quantity and number of times you can purchase
                        Virtual Goods, Game Currency, or other aspects of your Transaction. For
                        example, there may be a maximum amount of Game Currency you are able to hold
                        (in-Game) or purchase at a given time, or a maximum number of Transactions you
                        may make per day; these additional restrictions may be communicated to you via
                        the functionality of the Services. We may, from time to time, modify, amend, or
                        supplement our fees, billing methods and terms applicable to Game Currency,
                        Virtual Goods or to any purchases, and post those changes in this TERMS OF
                        SERVICE, in separate terms and conditions or in other terms or agreements
                        posted on the applicable website or as part of the Game or otherwise provided
                        to you by us. Except where prohibited by law in your jurisdiction, such
                        modifications, amendments, supplements or terms shall be effective immediately
                        upon posting and shall be incorporated by reference into this TERMS OF SERVICE.
                        If any change is unacceptable to you, you may terminate the use of your Game
                        Account at any time.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><a name="_Ref67769540"><span class="index" style="
                        ">(b)</span></a><span style="mso-bookmark:_Ref67769540"><span  style="
                        
                        ">&nbsp;</span></span><span style="mso-bookmark:_Ref67769540"><u><span  style="
                        
                        ">Your License to Virtual Goods and Game Currency</span></u></span><span style="mso-bookmark:_Ref67769540"></span><span  style="
                        
                        ">. Virtual Goods and Game Currency are digital
                        items and your use of them is governed by this TERMS OF SERVICE and the App
                        Store Agreement(s).&nbsp; VIRTUAL GOODS AND GAME CURRENCY HAVE NO MONETARY
                        VALUE AND CANNOT BE REDEEMED FOR CASH. VIRTUAL GOODS AND GAME CURRENCY ARE
                        NON-TRANSFERABLE AND NON-TRADABLE, IN WHOLE OR PART, AND ARE NOT PROVIDED FOR
                        INVESTMENT PURPOSES.&nbsp;Virtual Goods and Game Currency are licensed, not
                        sold.&nbsp;Provided you comply with the terms of this TERMS OF SERVICE and the
                        App Store Agreement(s), we grant you the following license: a personal,
                        non-exclusive, non-transferable, non-sublicensable limited right and license to
                        use any Virtual Goods or Game Currency you gain access to, whether purchased or
                        otherwise obtained, solely in connection with your use of the Game&nbsp;in
                        question&nbsp;and within the Game (unless we otherwise communicate to you that
                        you may use them in multiple Games) and for no other purpose.&nbsp; Unless,
                        expressly permitted by us in a specific Game, you may not trade any such
                        Virtual Good or Game Currency with others. We may cancel, revoke, or otherwise
                        prevent the use of Virtual Good or Game Currency if we suspect any unauthorized
                        or fraudulent activity, and/or to correct any erroneous application of any
                        Virtual Goods or Game Currency to your Account.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><a name="_Ref67769194"><span class="index" style="
                        ">(c)</span></a><span style="mso-bookmark:_Ref67769194"><span  style="
                        
                        "></span></span><span style="mso-bookmark:_Ref67769194"><u><span  style="
                        
                        ">Changes to Game Currency and Virtual Goods.</span></u></span><span style="mso-bookmark:_Ref67769194"></span><span  style="
                        
                        ">&nbsp;Except as otherwise prohibited by
                        applicable law, we, in our sole discretion, may modify, substitute, replace,
                        suspend, cancel or eliminate any Game Currency or Virtual Goods, including your
                        ability to access or use Game Currency or Virtual Goods, without notice or
                        liability to you, such as if we need to temporarily suspend the Game to make
                        updates, have an emergency that requires us to disable our Services, or if we
                        need to ultimately shut a Game down for economic or other reasons due to a
                        limited number of users continuing to make use of the online Service over time.
                        YOU AGREE THAT YOU WON’T ASSERT OR BRING ANY CLAIM AGAINST US, OUR AFFILIATES,
                        DIRECTORS, OFFICERS, EMPLOYEES, AGENTS, OR LICENSORS (THE “<b>COMPANY PARTIES</b>”)
                        RELATING TO (A) A CLAIM THAT YOU HAVE A PROPRIETARY INTEREST IN ANY GAME
                        CURRENCY OR VIRTUAL GOODS; OR (B) A CLAIM FOR AN ALLEGED MONETARY VALUE OF GAME
                        CURRENCY OR VIRTUAL GOODS LOST UPON (I) DELETION OR SUSPENSION OF YOUR ACCOUNT,
                        (II) ADJUSTMENTS TO THE GAME THAT RESULT IN THE VALUE OF VIRTUAL GOODS OR GAME
                        CURRENCY CHANGING, OR (III) MODIFICATION, TERMINATION OR EXPIRATION OF THIS TERMS
                        OF SERVICE.<o:p></o:p></span></p>
                        
                        <p  class="title-big"><a name="_Ref530935558"></a><a name="_Toc77497109"></a><a name="_Toc1401374"></a><a name="_Toc19737867"></a><a name="_Toc1052388"></a><span style="mso-bookmark:_Ref530935558"><b><span  style="
                        ">10.</span></b></span><span style="mso-bookmark:_Ref530935558"><b><span  style="
                        
                        ">&nbsp;&nbsp;</span></b></span><span style="mso-bookmark:_Ref530935558"><b><span  style="
                        
                        ">Refunds</span></b></span><b><span  style="
                        "><o:p></o:p></span></b></p>
                        
                        <p  style="
                        "><span  style="
                        ">Subject to applicable law (including as
                        described in each country-specific addendum below), or App Store policy, (i)
                        all Games, Virtual Goods and Game Currency remain our property, have no
                        monetary value and are not redeemable, refundable, or eligible for any other
                        alternate remedy for any “real world” money or anything of monetary value,
                        unless they are defective, unavailable, or do not perform in accordance with
                        the specifications we provide; (ii) we may revoke your license to such Games,
                        Virtual Goods and/or Game Currency at any time consistent with this TERMS OF
                        SERVICE without notice or liability to you; and (iii) except where the law in
                        your jurisdiction provides a right of withdrawal that cannot be waived by
                        contract,&nbsp;by purchasing and using any Games, Virtual Goods and/or Game
                        Currency, you hereby waive your right to withdraw from your agreement to
                        purchase the applicable Game, Virtual and/or Game Currency and you agree that
                        you will therefore not be eligible to receive a refund (or any alternative
                        remedy) in relation to such Game, Virtual Good and/or Game Currency.
                        Additionally, you hereby agree that any withdrawal right expires immediately
                        upon purchase and delivery of your Game, Virtual Good and/or Game Currency,
                        unless the law in your jurisdiction provides otherwise. This section does not
                        affect your statutory rights.&nbsp; &nbsp;<o:p></o:p></span></p>
                        
                        <p  class="title-big"><a name="_Toc1052389"></a><a name="_Ref498960534"></a><a name="_Toc77497110"></a><a name="_Ref67769297"></a><a name="_Toc1401375"></a><a name="_Toc19737868"></a><span style="mso-bookmark:
                        _Toc1052389"><b><span  style="
                        ">11.</span></b></span><span style="mso-bookmark:_Toc1052389"><b><span  style="
                        
                        ">&nbsp;&nbsp;</span></b></span><span style="mso-bookmark:_Toc1052389"><b><span  style="
                        
                        ">Beta Testing</span></b></span><b><span  style="
                        "><o:p></o:p></span></b></p>
                        
                        <p  style="
                        "><span  style="
                        ">From time to time we may offer a beta
                        version of one of our Services (a “<b>Beta</b>”). As the name implies, Betas
                        are not commercial launch versions, are not guaranteed to work properly, and
                        may make other parts of your system not work properly as well. For the license
                        granted to you in Section&nbsp;6&nbsp;above to extend to the Beta (meaning, for
                        you to have permission to use the Beta), you acknowledge and agree to the
                        following terms in addition to the rest of this TERMS OF SERVICE:<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(a)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">We may
                        automatically delete or modify the information stored on your computer related
                        to the Beta for any reason at any time during the duration of the Beta test;<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(b)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">We may terminate
                        the Beta test at any time, which would then render your Beta unplayable or
                        unable to function properly. When we terminate a Beta, you must delete the
                        local Beta instance on your computer and all documents and materials you
                        received from us in connection with the Beta;<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(c)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">Use of a Beta is
                        subject to confidential treatment of that Beta and all elements thereof.
                        "Confidential Information" means any information disclosed by us to
                        you, or accessed or provided by you, in relation to the Beta (including any
                        feedback provided and the Game itself). You agree that you will:<o:p></o:p></span></p>
                        
                        <p  style="
                        text-indent:20.0pt;;mso-outline-level:
                        3"><span  style="
                        ">(i)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">not use any
                        Confidential Information other than as necessary to use the Beta in accordance
                        with this TERMS OF SERVICE;<o:p></o:p></span></p>
                        
                        <p  style="
                        text-indent:20.0pt;;mso-outline-level:
                        3"><span  style="
                        ">(ii)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">maintain
                        Confidential Information in strict confidence and use the same degree of care
                        to protect it as you use to protect your own confidential information, but in
                        no circumstances less than reasonable care;<o:p></o:p></span></p>
                        
                        <p  style="
                        text-indent:20.0pt;;mso-outline-level:
                        3"><span  style="
                        ">(iii)</span><span  style="
                        ">&nbsp;&nbsp;</span><span  style="
                        ">not disclose the
                        Confidential Information to any person or entity other than as permitted by us;
                        and<o:p></o:p></span></p>
                        
                        <p  style="
                        text-indent:20.0pt;;mso-outline-level:
                        3"><span  style="
                        ">(iv)</span><span  style="
                        ">&nbsp;&nbsp;</span><span  style="
                        ">not make any
                        public announcements related to Beta or the Service, including publishing or
                        disclosing any information (e.g. screenshots and specifications) relating to
                        the Beta, without our prior written approval, which we may grant or withhold in
                        our sole discretion.&nbsp;<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(d)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">Termination of a
                        Beta by us is not grounds for any kind of refund and your participation in a
                        Beta does not entitle you to any compensation or any free Services, including
                        any Content and Game Currency; and<o:p></o:p></span></p>
                        
                        <p  style="
                        "><a name="_Ref19285649"><span  style="
                        ">If and when we
                        release a full (non-Beta) version of the particular Game and we may allow your
                        use of the Game to continue to the full version. If so allowed by us, your
                        continued use of the Game will no longer be subject to this Section&nbsp;</span></a><span  style="
                        ">11&nbsp;but will
                        still be subject to the rest of this TERMS OF SERVICE.<o:p></o:p></span></p>
                        
                        <p  class="title-big"><a name="_Ref524372603"></a><a name="_Toc77497111"></a><a name="_Ref67769303"></a><a name="_Toc1401376"></a><a name="_Toc19737869"></a><a name="_Toc1052390"></a><span style="mso-bookmark:
                        _Ref524372603"><b><span  style="
                        ">12.</span></b></span><span style="mso-bookmark:_Ref524372603"><b><span  style="
                        
                        ">&nbsp;&nbsp;</span></b></span><span style="mso-bookmark:_Ref524372603"><b><span  style="
                        
                        ">App Store</span></b></span><b><span  style="
                        ">; Console Games<o:p></o:p></span></b></p>
                        
                        <p  style="
                        "><span  style="
                        ">Where a Game is made available to you
                        via an App Store (whether on your mobile device or console) you acknowledge and
                        agree to the terms in Schedule B-1 with respect to such Game.<o:p></o:p></span></p>
                        
                        <p  class="title-big"><a name="_Toc77497116"></a><a name="_Toc1401377"></a><a name="_Toc19737870"></a><a name="_Toc1052391"></a><a name="_Ref526358605"></a><a name="_Toc77497112"></a><a name="_Toc77497113"></a><a name="_Toc77497114"></a><a name="_Toc77497115"></a><b><span  style="
                        ">13.</span></b><b><span  style="
                        ">&nbsp;&nbsp;</span></b><b><span  style="
                        ">Feedback<o:p></o:p></span></b></p>
                        
                        <p  style="
                        "><span  style="
                        ">We welcome your feedback, comments and
                        suggestions for improvements to the Services (“<b>Feedback</b>”). You can
                        submit Feedback by emailing us at </span><span  style="
                       ">support@sfduelmobile.zendesk.com</span><span  style="
                        "> or via the
                        functionality of the Services (if available). If you provide us with any
                        Feedback, you hereby grant us the following license: a non-exclusive,
                        transferable, worldwide, perpetual, irrevocable, fully-paid, royalty-free
                        license, with the right to sublicense, under any and all intellectual property
                        rights that you own or control to use, copy, modify, create derivative works
                        based upon, distribute copies of, publicly perform, publicly display and
                        otherwise exploit the Feedback for any purpose and in any country. This license
                        does not lapse or expire even if we do not exercise our rights under this
                        license within a period of one year. If you have rights in the Feedback that
                        cannot be licensed to us under applicable law (such as moral and other personal
                        rights), you hereby waive and agree not to assert those rights. You understand
                        and agree that you are freely giving your Feedback, that we don’t have to use
                        it, and that you will not be compensated in any way for your Feedback. You
                        represent and warrant that you have rights in any Feedback that you provide to
                        us sufficient to grant us and other affected parties the rights described
                        above, including, without limitation, intellectual property rights or rights of
                        publicity or privacy.&nbsp; &nbsp;<a name="_Toc1401379"></a><o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">In posting such Feedback, you warrant
                        that your feedback is in compliance with this TERMS OF SERVICE and you will not
                        use obscene or offensive language or submit any material that is, or may
                        potentially be, defamatory, abusive or hateful, an invasion of anyone's
                        privacy, harmful to other users, or in breach of any applicable
                        law.&nbsp;&nbsp;<o:p></o:p></span></p>
                        
                        <p  class="title-big"><a name="_Toc19737871"></a><a name="_Toc77497117"></a><span style="mso-bookmark:_Toc19737871"><b><span  style="
                        ">14.</span></b></span><span style="mso-bookmark:_Toc19737871"><b><span  style="
                        
                        ">&nbsp;&nbsp;</span></b></span><span style="mso-bookmark:_Toc19737871"><b><span  style="
                        
                        ">DMCA/Copyright Policy</span></b></span><b><span  style="
                        ">&nbsp;<o:p></o:p></span></b></p>
                        
                        <p  style="
                        "><span  style="
                        ">We respect copyright law and expect our
                        users to do the same. It’s our policy to terminate in appropriate circumstances
                        Game Accounts of users who repeatedly infringe or are believed to be repeatedly
                        infringing the rights of copyright holders.<o:p></o:p></span></p>
                        
                        <p class="title-big"><a name="_Toc1052393"></a><a name="_Toc77497118"></a><a name="_Toc1401380"></a><a name="_Toc19737872"></a><a name="_Ref19286516"></a><span style="mso-bookmark:_Toc1052393"><b><span  style="
                        ">15.</span></b></span><span style="mso-bookmark:_Toc1052393"><b><span  style="
                        
                        ">&nbsp;&nbsp;</span></b></span><span style="mso-bookmark:_Toc1052393"><b><span  style="
                        
                        ">Third-Party Websites and Resources</span></b></span><b><span  style="
                        "><o:p></o:p></span></b></p>
                        
                        <p  style="
                        "><span  style="
                        ">The Services may contain links to
                        third-party websites or resources. We provide these links only as a convenience
                        and are not responsible for the content, products or services on or available
                        from those websites or resources or links displayed on such websites. You
                        acknowledge sole responsibility for and assume all risk arising from, your use
                        of any third-party websites or resources.<a name="_Ref523929224"></a><o:p></o:p></span></p>
                        
                        <p  class="title-big"><a name="_Toc1052394"></a><a name="_Ref526360052"></a><a name="_Toc77497119"></a><a name="_Toc1401381"></a><a name="_Toc19737873"></a><span style="mso-bookmark:_Toc1052394"><b><span  style="
                        ">16.</span></b></span><span style="mso-bookmark:_Toc1052394"><b><span  style="
                        
                        ">&nbsp;&nbsp;</span></b></span><span style="mso-bookmark:_Toc1052394"><b><span  style="
                        
                        ">Data Charges and Mobile Devices</span></b></span><b><span  style="
                        "><o:p></o:p></span></b></p>
                        
                        <p  style="
                        "><span  style="
                        ">You are responsible for all data-related
                        charges that you may incur for using our Services, including, without
                        limitation, mobile, text-messaging, and data charges. You should understand or
                        ask your service provider what charges you may incur before using the Services.<o:p></o:p></span></p>
                        
                        <p class="title-big"><a name="_Ref1401740"></a><a name="_Toc77497120"></a><a name="_Toc1401382"></a><a name="_Toc19737874"></a><a name="_Toc1052395"></a><span style="mso-bookmark:_Ref1401740"><b><span  style="
                        ">17.</span></b></span><span style="mso-bookmark:_Ref1401740"><b><span  style="
                        
                        ">&nbsp;&nbsp;</span></b></span><span style="mso-bookmark:_Ref1401740"><b><span  style="
                        
                        ">Service and Modifications</span></b></span><b><span  style="
                        "><o:p></o:p></span></b></p>
                        
                        <p  style="
                        "><span  style="
                        ">We may (but don’t have to) update this TERMS
                        OF SERVICE at any time whenever we think there is a need. Subject to applicable
                        law, if we do so, you will be prompted to agree to the updated TERMS OF SERVICE
                        upon your next access to the Services or when the updated TERMS OF SERVICE is
                        otherwise communicated to you. You must agree to these updates to continue
                        using the Services.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">We may provide patches, updates, or
                        upgrades to the Services that must be installed in order for you to continue to
                        use the Services. We may update the Services remotely without notifying you,
                        and you hereby consent to us applying such patches, updates, and upgrades. If
                        your device can prevent automatic updates, you may not be able to access the
                        Services until you manually update the Services yourself on your device. We may
                        modify, suspend, discontinue, substitute, replace, or limit your access to any
                        aspect of the Services at any time. Subject to applicable law, you acknowledge
                        that any character data, game progress, game customization or other data
                        related to your use of any particular Game and other elements unique to the
                        Services may cease to be available to you at any time without notice from us,
                        including, without limitation, after a patch, update, or upgrade is applied by
                        us. You agree that we do not have any maintenance or support obligations with
                        respect to the Services.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">Subject to applicable law, we may change
                        the price of the Services, Games, Virtual Goods, Game Currency or Content, at
                        any time, for any reason, without notice or liability to you.<o:p></o:p></span></p>
                        
                        <p class="title-big"><a name="_Toc1052396"></a><a name="_Toc77497121"></a><a name="_Ref67769420"></a><a name="_Ref67769328"></a><a name="_Ref67769312"></a><a name="_Ref67769266"></a><a name="_Ref67769249"></a><a name="_Toc1401383"></a><a name="_Toc19737875"></a><a name="_Ref19286519"></a><span style="mso-bookmark:_Toc1052396"><b><span  style="
                        
                        ">18.</span></b></span><span style="mso-bookmark:_Toc1052396"><b><span  style="
                        ">&nbsp;&nbsp;</span></b></span><span style="mso-bookmark:_Toc1052396"><b><span  style="
                        
                        ">Warranty Disclaimers</span></b></span><b><span  style="
                        "><o:p></o:p></span></b></p>
                        
                        <p  style="
                        "><span  style="
                        ">TO THE MAXIMUM EXTENT PERMITTED BY LAW
                        THE SERVICES ARE PROVIDED “AS IS,” WITHOUT WARRANTY OF ANY KIND. WITHOUT LIMITING
                        THE FOREGOING, THE COMPANY PARTIES EXPLICITLY DISCLAIM ANY IMPLIED WARRANTIES
                        OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, QUIET ENJOYMENT AND
                        NON-INFRINGEMENT, AND ANY WARRANTIES ARISING OUT OF COURSE OF DEALING OR USAGE
                        OF TRADE. The Company Parties make no warranty that the Services will meet your
                        requirements or be available on an uninterrupted, secure, or error-free basis.
                        The Company Parties make no warranty regarding the quality, accuracy,
                        timeliness, truthfulness, completeness or reliability of the Services.<o:p></o:p></span></p>
                        
                        <p  class="title-big"><a name="_Ref523929225"></a><a name="_Toc77497122"></a><a name="_Toc1401384"></a><a name="_Toc19737876"></a><a name="_Toc1052397"></a><span style="mso-bookmark:_Ref523929225"><b><span  style="
                        ">19.</span></b></span><span style="mso-bookmark:_Ref523929225"><b><span  style="
                        
                        ">&nbsp;&nbsp;</span></b></span><span style="mso-bookmark:_Ref523929225"><b><span  style="
                        
                        ">Limitation of Liability</span></b></span><b><span  style="
                        "><o:p></o:p></span></b></p>
                        
                        <p  style="
                        "><span  style="
                        ">TO THE MAXIMUM EXTENT PERMITTED BY
                        APPLICABLE LAW THE COMPANY PARTIES WILL NOT BE LIABLE IN ANY WAY FOR ANY:<o:p></o:p></span></p>
                        
                        <p  style="
                        "><a name="_Ref67769437"><span  class="index" style="
                        ">(a)</span></a><span style="mso-bookmark:_Ref67769437"><span  style="
                        
                        ">&nbsp;</span></span><span style="mso-bookmark:_Ref67769437"><span  style="
                        
                        ">LOSS OF PROFITS,</span></span><span  style="
                        "><o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(b)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">LOST REVENUE,<o:p></o:p></span></p>
                        
                        <p  style="
                        "><a name="_Ref67769568"><span class="index" style="
                        ">(c)</span></a><span style="mso-bookmark:_Ref67769568"><span  style="
                        
                        "></span></span><span style="mso-bookmark:_Ref67769568"><span  style="
                        
                        ">LOST SAVINGS,</span></span><span  style="
                        "><o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(d)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">LOSS OF DATA, OR<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(e)</span><span  style="
                        ">&nbsp;</span><span  style="
                        ">ANY INDIRECT,
                        INCIDENTAL, CONSEQUENTIAL, SPECIAL, PUNITIVE, OR EXEMPLARY DAMAGES,<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">ARISING OUT OF OR IN CONNECTION WITH
                        THIS TERMS OF SERVICE OR THE SERVICES, OR THE DELAY OR INABILITY TO USE OR LACK
                        OF FUNCTIONALITY OF THE SERVICES, EVEN IN THE EVENT OF ONE OF A COMPANY PARTY’S
                        FAULT, TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY, INDEMNITY, PRODUCT
                        LIABILITY, BREACH OF CONTRACT, BREACH OF WARRANTY, OR OTHERWISE AND EVEN IF
                        THAT COMPANY PARTY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.&nbsp;
                        FURTHER, TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE AGGREGATE
                        LIABILITY OF THE COMPANY PARTIES ARISING OUT OF OR IN CONNECTION WITH THIS TERMS
                        OF SERVICE OR THE SERVICES WILL NOT EXCEED: (A) THE TOTAL AMOUNTS YOU HAVE PAID
                        (IF ANY) OR ARE PAYABLE BY YOU TO US FOR THE PARTICULAR GAME OR SERVICE IN
                        QUESTION DURING THE SIX (6) MONTHS IMMEDIATELY PRECEDING THE EVENTS GIVING RISE
                        TO SUCH LIABILITY; OR (B) IF (A) DOES NOT APPLY, FIFTY DOLLARS ($50 USD). THESE
                        LIMITATIONS AND EXCLUSIONS REGARDING DAMAGES APPLY EVEN IF ANY REMEDY FAILS TO
                        PROVIDE ADEQUATE COMPENSATION AND ARE FUNDAMENTAL ELEMENTS OF THE BASIS OF THE
                        BARGAIN BETWEEN YOU AND US.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">Notwithstanding the foregoing, some countries,
                        states, provinces or other jurisdictions do not allow the exclusion of certain
                        warranties or the limitation of liability as stated above, so the above terms
                        may not apply to you. Instead, in such jurisdictions, the foregoing exclusions
                        and limitations will apply to the maximum extent permitted by the laws of such
                        jurisdictions. Also, you may have additional legal rights in your jurisdiction,
                        and nothing in this TERMS OF SERVICE will prejudice such rights that you may
                        have as a consumer of the Services.<o:p></o:p></span></p>
                        
                        <p  class="title-big"><a name="_Ref523929229"></a><a name="_Toc77497123"></a><a name="_Toc1401385"></a><a name="_Toc19737877"></a><a name="_Toc1052398"></a><span style="mso-bookmark:_Ref523929229"><b><span  style="
                        ">20.</span></b></span><span style="mso-bookmark:_Ref523929229"><b><span  style="
                        
                        ">&nbsp;&nbsp;</span></b></span><span style="mso-bookmark:_Ref523929229"><b><span  style="
                        
                        ">Indemnity</span></b></span><b><span  style="
                        "><o:p></o:p></span></b></p>
                        
                        <p  style="
                        "><span  style="
                        ">You agree to indemnify (in other words,
                        compensate for all and any losses incurred), pay the defense costs of, and hold
                        the Company Parties and their employees, officers, directors, agents,
                        contractors, and other representatives harmless from all claims, demands,
                        actions, losses, liabilities, costs and expenses (including, without
                        limitation, attorneys’ fees, costs, and expert witnesses’ fees) that arise out
                        of or in any way are connected with: (a) your access to or use of the Services;
                        or (b) any claim that, if true, would constitute a breach by you of this TERMS
                        OF SERVICE. You agree to reimburse us for any payments made or loss suffered by
                        us, whether in a court judgment or settlement, based on any matter covered by
                        this Section&nbsp;20.<o:p></o:p></span></p>
                        
                        <p  class="title-big"><a name="_Ref523929234"></a><a name="_Toc77497124"></a><a name="_Toc1401386"></a><a name="_Toc19737878"></a><a name="_Toc1052399"></a><span style="mso-bookmark:_Ref523929234"><b><span  style="
                        ">21.</span></b></span><span style="mso-bookmark:_Ref523929234"><b><span  style="
                        
                        ">&nbsp;&nbsp;</span></b></span><span style="mso-bookmark:_Ref523929234"><b><span  style="
                        
                        ">Termination</span></b></span><b><span  style="
                        "><o:p></o:p></span></b></p>
                        
                        <p  style="
                        "><span  style="
                        ">To the fullest extent consistent with
                        applicable law, we may suspend, modify or terminate your access to and use of
                        the Services, including any Game, Virtual Goods, and Content, with no liability
                        or notice to you in the event that (a) we cease providing the Game to similarly
                        situated users generally; (b) you breach any terms of this TERMS OF SERVICE
                        (including the App Store Agreement(s) and our other policies specified in this TERMS
                        OF SERVICE); (c) the owner of the applicable App Store terminates your App
                        Store Account; or (d) we otherwise deem it necessary to suspend or modify your
                        access to and use of the Services or terminate this TERMS OF SERVICE in our
                        sole discretion. You may also terminate this TERMS OF SERVICE by deleting and
                        uninstalling the Game on any and all of your devices or by deleting your App
                        Store Account. &nbsp;A suspension or modification of your access to and use of
                        the Services will result in your inability to access and use some or all
                        features of the Services, as determined by us in our sole discretion. Upon any
                        termination of this TERMS OF SERVICE, the rights granted to you will
                        automatically terminate, you may no longer exercise any of those rights or this
                        TERMS OF SERVICE. &nbsp;Subject to applicable law, we may, in our sole
                        discretion, provide continued access to and use of the Services after such
                        termination.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">Where required by applicable law,
                        termination of this TERMS OF SERVICE does not require a court decision to
                        affect termination or a notice served by a court bailiff as a prerequisite to
                        termination.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">Except to the extent required by law,
                        all payments and fees are non-refundable under all circumstances, regardless of
                        whether or not this TERMS OF SERVICE has been terminated.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">The following sections will survive
                        termination of this TERMS OF SERVICE:&nbsp;8&nbsp;(first two sentences
                        only),&nbsp;13,&nbsp;19,&nbsp;20,&nbsp;22&nbsp;through&nbsp;25, and this
                        sentence of Section&nbsp;21.<o:p></o:p></span></p>
                        
                        <p  class="title-big"><a name="_Ref526358948"></a><a name="_Toc77497125"></a><a name="_Toc1401387"></a><a name="_Toc19737879"></a><a name="_Toc1052400"></a><a name="_Ref526359244"></a><span style="mso-bookmark:
                        _Ref526358948"><b><span  style="
                        ">22.</span></b></span><span style="mso-bookmark:_Ref526358948"><b><span  style="
                        
                        ">&nbsp;&nbsp;</span></b></span><span style="mso-bookmark:_Ref526358948"><b><span  style="
                        
                        ">Dispute Resolution</span></b></span><b><span  style="
                        ">&nbsp;and
                        Governing Law<o:p></o:p></span></b></p>
                        
                        <p  style="
                        "><span  style="
                        ">These Terms and
                        any action related thereto will be governed by the laws of People’s Republic of
                        China without regard to its conflict of laws provisions. Any dispute arising
                        from or in connection with These Terms shall be submitted to Hong Kong
                        International Arbitration Center (“HKIAC”) for arbitration, which shall be
                        conducted in accordance with HKIAC's arbitration rules in effect at the time of
                        applying for arbitration. The seat of arbitration shall be Hong Kong. The
                        language to be used in the arbitral proceedings shall be English. The arbitral
                        award is final and binding upon both parties.</span><span  style="
                        "><o:p></o:p></span></p>
                        
                        <p  class="title-big"><a name="_Toc77497134"></a><a name="_Ref67769504"></a><a name="_Toc1401389"></a><a name="_Toc19737881"></a><a name="_Toc1052402"></a><a name="_Toc77497126"></a><a name="_Toc77497127"></a><a name="_Toc77497128"></a><a name="_Toc77497129"></a><a name="_Toc77497130"></a><a name="_Toc77497131"></a><a name="_Toc77497132"></a><a name="_Toc77497133"></a><b><span  style="
                        ">23.</span></b><b><span  style="
                        ">&nbsp;&nbsp;</span></b><b><span  style="
                        ">No Assignment<o:p></o:p></span></b></p>
                        
                        <p  style="
                        "><span  style="
                        ">You may not assign or transfer this TERMS
                        OF SERVICE, by operation of law or otherwise, without our prior written
                        consent. Any attempt by you to assign or transfer this TERMS OF SERVICE,
                        without such consent, will be null and void. Notwithstanding the title of this
                        Section, we may freely assign or transfer this TERMS OF SERVICE without
                        restriction. Subject to the foregoing, this TERMS OF SERVICE will bind and
                        inure to the benefit of the parties, their successors and permitted assigns.<o:p></o:p></span></p>
                        
                        <p  class="title-big"><a name="_Toc1052403"></a><a name="_Toc77497135"></a><a name="_Toc1401390"></a><a name="_Toc19737882"></a><span style="mso-bookmark:_Toc1052403"><b><span  style="
                        
                        ">24.</span></b></span><span style="mso-bookmark:_Toc1052403"><b><span  style="
                        ">&nbsp;&nbsp;</span></b></span><span style="mso-bookmark:_Toc1052403"><b><span  style="
                        
                        ">Miscellaneous</span></b></span><b><span  style="
                        "><o:p></o:p></span></b></p>
                        
                        <p  style="
                        "><span  class="index" style="
                        ">(a)</span><span  style="
                        ">&nbsp;</span><u><span  style="
                        ">Entire Agreement</span></u><i><span  style="
                        ">.&nbsp;</span></i><span  style="
                        ">This TERMS OF
                        SERVICE and any other document or information referred to in this TERMS OF
                        SERVICE constitutes the entire and exclusive understanding between you and us
                        regarding the Services and supersede any and all prior oral or written
                        understandings or agreements between you and us regarding the Services.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><a name="_Ref67769514"><span class="index" style="
                        ">(b)</span></a><span style="mso-bookmark:_Ref67769514"><span  style="
                        
                        ">&nbsp;</span></span><span style="mso-bookmark:_Ref67769514"><u><span  style="
                        
                        ">Language</span></u></span><span style="mso-bookmark:_Ref67769514"></span><i><span  style="
                        ">.&nbsp;</span></i><span  style="
                        ">The original language
                        of this TERMS OF SERVICE is in English; any translations are provided for
                        reference purposes only. To the maximum extent permitted by applicable law, you
                        waive any right you may have under the law of your country to have this TERMS
                        OF SERVICE written or construed in any other language.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(c)</span><span  style="
                        "></span><u><span  style="
                        ">Severability</span></u><i><span  style="
                        ">.&nbsp;</span></i><span  style="
                        ">This TERMS OF
                        SERVICE describes certain legal rights. You may have other rights under the
                        laws of your jurisdiction. This TERMS OF SERVICE does not change your rights
                        under the laws of your jurisdiction if the laws of your jurisdiction do not
                        permit it to do so. As noted above, limitations and exclusions of warranties
                        and remedies in this TERMS OF SERVICE may not apply to you because your
                        jurisdiction may not allow them in your particular circumstance. In the event
                        that certain provisions of this TERMS OF SERVICE are held by a court or
                        tribunal of competent jurisdiction to be unenforceable, those provisions will
                        be enforced only to the furthest extent possible under applicable law and, the
                        remaining terms of this TERMS OF SERVICE will remain in full force and effect.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(d)</span><span  style="
                        ">&nbsp;</span><u><span  style="
                        ">No Waiver</span></u><i><span  style="
                        ">.&nbsp;</span></i><span  style="
                        ">Your and our
                        actions or inactions will not create any other rights under this TERMS OF
                        SERVICE except as what is explicitly written within this TERMS OF SERVICE.<i>&nbsp;</i>Our
                        failure to enforce any right or provision of this TERMS OF SERVICE will not be
                        considered a waiver of such right or provision. The waiver of any such right or
                        provision will be effective only if in writing and signed by one of our duly
                        authorized representatives. Except as expressly set forth in this TERMS OF
                        SERVICE, the exercise by either party of any of its remedies under this TERMS
                        OF SERVICE will be without prejudice to its other remedies under this TERMS OF
                        SERVICE or otherwise.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(e)</span><span  style="
                        ">&nbsp;</span><u><span  style="
                        ">Your Status</span></u><span  style="
                        ">.&nbsp;You are
                        not, nor acting on behalf of anyone who is:<o:p></o:p></span></p>
                        
                        <p  style="margin-bottom:
                        10.0pt;"><span  style="
                        ">a.</span><span  style="
                        ">&nbsp;&nbsp;&nbsp;</span><span  style="
                        ">subject to
                        sanctions or export restrictions maintained by the United Nations, People’s
                        Republic of China, United States (<i>e.g.</i>, the Specially Designated
                        Nationals and Blocked Persons List (“SDN List”) or the Entity List), the United
                        Nations Security Council, the United Kingdom (including the Consolidated List
                        of Financial Sanctions Targets), the European Union and any Member State
                        thereof (including the Consolidated List of Persons, Groups and Entities
                        Subject to Financial Sanctions), or any other list of restricted
                        persons&nbsp; maintained by any authority with jurisdiction over
                        you (any person so listed being a “<b>Restricted Person</b>”);<o:p></o:p></span></p>
                        
                        <p  style="margin-bottom:
                        10.0pt;"><span  style="
                        ">b.</span><span  style="
                        ">&nbsp;&nbsp;&nbsp;</span><span  style="
                        ">operating from
                        or located or resident in a country or territory that is the target of
                        comprehensive sanctions (“<b>Embargoed Territories</b>”).<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(f)</span><span  style="
                        ">&nbsp;</span><u><span  style="
                        ">General Trade
                        Compliance</span></u><span  style="
                        ">. In connection
                        with your use of the Services, you will comply with all applicable export
                        controls and economic sanctions laws and regulations of the United Nations,
                        People’s Republic of China, United States, European Union, United Kingdom, and
                        other applicable government authorities (collectively, “<b>Trade Laws</b>”).
                        You agree not to engage in any activities in connection with the use of the
                        Services that would violate Trade Laws or that would risk placing us in breach
                        of any Trade Laws. If we have reasons to believe that you are a Restricted
                        Person, are in or a resident of Embargoed Territories, or otherwise engaging in
                        activities that violate Trade Laws or would risk placing us in breach of any
                        Trade Laws, we may, at our sole discretion, take any and all relevant actions,
                        such as requesting you to cease the conduct that violates Trade Laws, disabling
                        or suspending Services, terminating Services with immediate eﬀect, or other
                        remedial actions.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span class="index" style="
                        ">(g)</span><span  style="
                        ">&nbsp;</span><u><span  style="
                        ">Third-Party
                        Rights</span></u><i><span  style="
                        ">.</span></i><span  style="
                        ">&nbsp;Except as
                        described in Section&nbsp;12, a person who is not a party to this TERMS OF
                        SERVICE will have no right under to enforce any of its terms.<o:p></o:p></span></p>
                        
                        <p  class="title-big"><a name="_Toc77497136"></a><a name="_Toc1401391"></a><a name="_Toc1052404"></a><a name="_Ref523929250"></a><span style="mso-bookmark:_Toc77497136"><b><span  style="
                        
                        ">25.</span></b></span><span style="mso-bookmark:_Toc77497136"><b><span  style="
                        ">&nbsp;&nbsp;</span></b></span><span style="mso-bookmark:_Toc77497136"><b><span  style="
                        
                        ">Contact Information</span></b></span><b><span  style="
                        "><o:p></o:p></span></b></p>
                        
                        <p  style="
                        "><span  style="
                        ">If you have any questions about this TERMS
                        OF SERVICE or have any requests for resolving issues arising from or in
                        connection with this TERMS OF SERVICE, we encourage you to primarily contact us
                        through the support features within each APLUS game, so we can reply to you
                        more quickly. Alternatively, you may contact:<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">Name of the controller: [SUSUMU TANAKA]<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">Address: Toranomon Hills Mori Tower 8F
                        1-23-1 Toranomon, Minato-ku, Tokyo Attn: Customer Service Department<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">email: </span><span  >support@sfduelmobile.zendesk.com</span><span  style="
                        "><o:p></o:p></span></p>
                        
                        
                        <p class="title_policy"><b><span  style="
                        ">Schedule B-1:
                        App Store Terms</span></b><span  ><o:p></o:p></span></p>
                        
                        <p  align="left" style="margin-bottom:
                        8.0pt;text-align:left;"><span  style="
                        ">If you download
                        a Game from the App Store, then notwithstanding anything in this TERMS OF
                        SERVICE to the contrary,&nbsp;you acknowledge and agree that:<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">·</span><span  style="
                        ">&nbsp;&nbsp;&nbsp;</span><span  style="
                        ">We, and not the
                        App Store, are solely responsible for the Game.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">·</span><span  style="
                        ">&nbsp;&nbsp;&nbsp;</span><span  style="
                        ">The App Store
                        has no obligation to provide any Game maintenance or support.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">·</span><span  style="
                        ">&nbsp;&nbsp;&nbsp;</span><span  style="
                        ">If the Game
                        cannot meet its warranties (if any), you may notify the App Store and the App
                        Store will refund you the purchase price of the Game (if applicable) and, to
                        the maximum extent permitted by applicable law, the App Store will have no
                        other warranty obligation whatsoever with respect to the Game. Any other
                        claims, losses, liabilities, damages, costs or expenses attributable to any
                        failure to conform to any warranty will be our sole responsibility.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">·</span><span  style="
                        ">&nbsp;&nbsp;&nbsp;</span><span  style="
                        ">The App Store is
                        not responsible for addressing any claims you have or any claims of any third
                        party relating to the Game or your possession and use of the Game, including,
                        without limitation: (i)&nbsp;product liability claims; (ii) any claim that the
                        Game fails to conform to any applicable legal or regulatory requirement; and
                        (iii) claims arising under consumer protection or similar legislation.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">·</span><span  style="
                        ">&nbsp;&nbsp;&nbsp;</span><span  style="
                        ">In the event of
                        any third party claim that the Game or your possession and use of the Game
                        infringes that third party’s intellectual property rights, we will be solely
                        responsible for the investigation, defense, settlement and discharge of any
                        such intellectual property infringement claim to the extent required by this TERMS
                        OF SERVICE.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">·</span><span  style="
                        ">&nbsp;&nbsp;&nbsp;</span><span  style="
                        ">The App Store,
                        and its subsidiaries, are third party beneficiaries of this TERMS OF SERVICE
                        and upon your acceptance of this TERMS OF SERVICE, the App Store will have the
                        right to enforce this TERMS OF SERVICE against you as a third-party beneficiary
                        thereof.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">·</span><span  style="
                        ">&nbsp;&nbsp;&nbsp;</span><span  style="
                        ">You represent
                        and warrant that (i) you are not located in a country that is subject to a U.S.
                        Government embargo, or that has been designated by the U.S. Government as a
                        terrorist-supporting country; and (ii) you are not listed on any U.S.
                        Government list of prohibited or restricted parties.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">·</span><span  style="
                        ">&nbsp;&nbsp;&nbsp;</span><span  style="
                        ">You must also
                        comply with all applicable third party terms of service or similar agreement
                        when using the Game.<o:p></o:p></span></p>
                        
                        <p class="title_policy"><b><span  style="
                        "><br clear="all">
                        Schedule C-1: Streaming Policy</span></b><span  style="
                        
                        "><o:p></o:p></span></p>
                        
                        <p  class="title-small" style="
                        "><i><u><span  style="
                        ">Introduction</span></u></i><i><span  style="
                        ">.</span></i><span  style="
                        "><o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">We hope that you enjoy our games and
                        support your interest in producing game-play videos, whether live or recorded
                        (“<b>Videos</b>”)</span><span>,</span><span  style="
                        ">&nbsp;that share
                        your gaming experiences with others, using images, video, sound effects,
                        in-game music or other assets from our games (“<b>Content</b>”). Please note
                        however, that in most cases using our Content without our permission is illegal
                        and a violation of our rights. This policy helps inform you of the limited
                        rights we grant you to share your experience with our Content with the public
                        in your Videos.<o:p></o:p></span></p>
                        
                        <p  class="title-small" style="
                        "><i><u><span  style="
                        ">Your use of our Content in Videos must
                        be limited to non-commercial purposes, except as expressly stated under this
                        Streaming Policy</span></u></i><i><span  style="
                        
                        ">:</span></i><span  style="
                        
                        "><o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">You may only use our Content in your Videos
                        for non-commercial uses, except as we expressly state under this Streaming
                        Policy. As such, you may not license your Video which leverages our Content to
                        any company or anyone else for a fee or other form of compensation or for any
                        other commercial use without first receiving our written authorization to do
                        so. Note that we reserve the right to use our own Videos for commercial
                        purposes. Further, any of your Videos that leverage our Content must contain
                        commentary, gameplay, or sufficient originality to make it, in our sole
                        discretion, educational or promotional. Examples of Videos that would NOT
                        qualify under this policy are clips of cut-scenes from games or recordings of a
                        particular game’s soundtrack (without any commentary discussing the cut-scene
                        or soundtrack).<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">We do however permit you to receive
                        payment based on the following two methods, provided you comply with the other
                        portions of this Streaming Policy:<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">·</span><span  style="
                        ">&nbsp;&nbsp;&nbsp;</span><span  style="
                        ">Monetization of
                        your Video that leverages our Content through advertisements served by the
                        platform which hosts your Video such as YouTube or Twitch (a “<b>Platform</b>”).<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">·</span><span  style="
                        ">&nbsp;&nbsp;&nbsp;</span><span  style="
                        ">Receiving
                        donations via a donation link posted on your profile or in the Video
                        description on a Platform.<o:p></o:p></span></p>
                        
                        <p  class="title-small" style="
                        "><i><u><span  style="
                        ">How you may distribute your Video</span></u></i><i><span  style="
                        ">:</span></i><span  style="
                        "><o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">Subject to the terms of the applicable TERMS
                        OF SERVICE and this Streaming Policy, you may create Videos using our Content,
                        and you’re free to distribute such Videos on websites where viewers are
                        permitted to view these Videos without any charge of any kind. We understand that
                        some websites may offer paid services. Provide that the website that hosts
                        these Videos provides a free method to allow viewers to view them, you may
                        distribute the Videos on that website.<o:p></o:p></span></p>
                        
                        <p  class="title-small" style="
                        "><i><u><span  style="
                        ">What you may not include in your Video
                        that leverages our Content</span></u></i><i><span  style="
                        
                        ">:</span></i><span  style="
                        "><o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">You may not include in any Video (nor
                        anywhere linked near or on the same webpage as the Video) any content that is
                        prohibited as User Content under the TERMS OF SERVICE and the following:<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">·</span><span  style="
                        ">&nbsp;&nbsp;&nbsp;</span><span  style="
                        ">Anything that
                        could imply that the Video is produced by us or that we endorse you or your
                        Video (unless you have an endorsement relationship with us as covered by a
                        separate written or other agreement);<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">·</span><span  style="
                        ">&nbsp;&nbsp;&nbsp;</span><span  style="
                        ">Any information
                        related to cheats, hacks, exploits, bugs, or third party programs, including
                        links to any of the foregoing; nor<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">·</span><span  style="
                        ">&nbsp;&nbsp;&nbsp;</span><span  style="
                        ">Uses of our
                        Content that breach applicable law or are derogatory to us or that, in our
                        discretion, may damage the value, goodwill, or reputation of us, our
                        affiliates, our products, Content, or brands.<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">·</span><span  style="
                        ">&nbsp;&nbsp;&nbsp;</span><span  style="
                        ">Any behavior or
                        conduct that violates public morals and ethics.<o:p></o:p></span></p>
                        
                        <p  class="title-small" style="
                        "><i><u><span  style="
                        ">Ratings – keep your Videos appropriate
                        as follows</span></u></i><i><span  style="
                        
                        ">:</span></i><span  style="
                        
                        "><o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">Your Video should match the ratings
                        guidelines for the game it relates to and must not in any event contain any
                        content that would violate the “T” rating of the Entertainment Software Rating
                        Board (“<b>ESRB</b>”) or the “16” rating of the Pan European Game Information
                        (“<b>PEGI</b>”).<o:p></o:p></span></p>
                        
                        <p  class="title-small" style="
                        "><i><u><span  style="
                        ">Disclosure – you must identify us as the
                        copyright holder of our Content and disclaim our endorsement</span></u></i><span  style="
                        ">:<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">In any Video that leverages our Content
                        that you provide, you must include a prominent disclaimer (either at the
                        beginning of the Video or, if live-streaming, near the Video in a visible font)
                        as follows:<o:p></o:p></span></p>
                        
                        <p  style="
                        "><span  style="
                        ">·</span><span  style="
                        ">&nbsp;&nbsp;&nbsp;</span><span  style="
                        ">Portions of the
                        content provided here, including trademarks and copyrights and any other
                        intellectual property rights, are owned or held by&nbsp;</span><a name="_Hlk119423940"><span  style="
                        ">A PLUS JAPAN Inc.</span></a><span style="mso-bookmark:_Hlk119423940"></span><span  style="
                        
                        ">&nbsp;or its licensor(s) (“APLUS”)&nbsp;and
                        all rights in and to the same are reserved by&nbsp;APLUS. This content is not
                        official&nbsp;APLUS&nbsp;content and is not endorsed or approved by&nbsp;APLUS.&nbsp;<o:p></o:p></span></p>
                        
                        <p  class="title-small" style="
                        "><i><u><span  style="
                        ">Some additional important information</span></u></i><i><span  style="
                        ">:</span></i><span  style="
                        "><o:p></o:p></span></p>
                        
                        <p  align="left" style="margin-bottom:
                        8.0pt;text-align:left;"><span  style="
                        ">As solely
                        determined by us, we may terminate your right to host, distribute or otherwise
                        make available a Video that leverages our Content for business or other reasons
                        without notice or liability to you.&nbsp; In such cases, we may (but do not
                        have to) contact you or applicable websites or Platforms regarding terminating
                        such rights to any such Video.<o:p></o:p></span></p>
                        
                        </div>



                </div>
            </div>
        </div>
    </div>

        </body>
        </html>

    `;
}

